PJQ.models.contacts = {};
PJQ.collections.contacts = {};
PJQ.views.contacts = {};

PJQ.helpers.contacts = {
    getContactAnchor: function (options = {}) {
        if (options.contact != null) {
            if (PJQ.helpers.objectHelpers.refinedType(options.contact, true) === 'backboneModel') {
                options.id = options.contact.get('id') != null ? options.contact.get('id') : options.contact.id;
                if (options.useCompanyName && options.contact.get('companyName') != null)
                    options.name = options.contact.get('companyName');
                else
                    options.name = options.contact.get('contactName');
            } else {
                options.id = options.contact.id;
                if (options.useCompanyName && options.contact.companyName != null)
                    options.name = options.contact.companyName;
                else
                    options.name = options.contact.contactName;
            }
        }

        if (_.size(options.name) == 0) {
            // options.name = '&lt;No Contact Name&gt;';
            options.name = '(No Contact Name)';
        }

        let canViewContacts = PJQ.app.session.hasPermission('contacts.canView');
        if (canViewContacts && PJQ.app.session.project != null && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
            canViewContacts = false;
        }

        if (options.id != null && options.id !== 0
            && ((PJQ.app.session.user != null && -options.id === PJQ.app.session.user.id)
                || canViewContacts
            )) {
            return `<a href="javascript:void(0)" class="font-weight-normal watch-contact-edit contact-name text-primary" data-contact-id="${options.id.toString()}">${options.name}</a>`;
        }

        return '<span>' + options.name + '</span>';
    }
};

//Models
PJQ.models.contacts.Company = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'companies',
                value: this.id
            }
        ])
    },
    beforeConstruct: function (attributes) {
        if (attributes && attributes.groups != null) {
            this.parseContactData(attributes);
        }
    },
    beforeInit: function () {
        this.on('change:userTypeId', function () {
            if (PJQ.app.session != null) {
                let userTypeId = this.get('userTypeId');
                if (userTypeId != null) {
                    this.userType = PJQ.app.session.userTypes.get(userTypeId);
                    if (this.userType === null) {
                        this.userType = PJQ.app.session.userTypes.getDefault(this.id < 0);
                    }
                } else {
                    this.userType = PJQ.app.session.userTypes.getDefault(this.id < 0);
                }
            }
        });
    },
    parse: function (model) {
        this.parseContactData(model);
        this.parseAttachmentData(model);
        return model;
    },
    parseContactData: function (model) {
        this.contacts = new PJQ.collections.contacts.Contacts(model ? model.contacts : null);
    },
    parseAttachmentData: function (model) {
        this.attachments = new PJQ.collections.files.Files(model ? model.attachments : null);
    },
    getGroups: function () {
        let result = [],
            ids = [];
        _.each(this.contacts.models, function (contact) {
            _.each(contact.groups.models, function (group) {
                if (ids.indexOf(group.id) === -1) {
                    ids.push(group.id);
                    result.push(group);
                }
            });
        });
        return result;
    },
    checkHasGroup: function (filter) {
        let result = false;
        _.each(this.contacts.models, function (contact) {
            result = result || contact.checkHasGroup(filter);
        });
        return result;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.getChangedModels()
        })
    },
    fetchERPObject: function (callback) {
        if (this.get('externalObject') == null && !this.externalObjectFetched) {
            this.externalObjectFetched = true;
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'contacts',
                        value: this.id
                    },
                    {
                        endpoint: 'erpobject'
                    }
                ]),
                isAPIv2: true
            }).get().done((data) => {
                if (data != null) {
                    this.set({
                        externalObject: data
                    }, {
                        silent: true
                    });
                }
                if (typeof callback === 'function') {
                    callback(this.get('externalObject'));
                }
            }).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            callback(this.get('externalObject'));
        }
    },
    erpSyncStatus: function (forCompany = false) {
        let exObj = this.get('externalObject');
        if (exObj != null) {
            let minModified = this.get('modifiedOn'),
                status = typeof exObj.status === 'number' ? exObj.status : 0;

            if (this.contacts != null) {
                minModified = _.min(_.union([minModified], _.map(this.contacts.models, function (contact) {
                    let mod = contact.get('modifiedOn');
                    return mod ? new Date(mod) : null;
                })))
            }

            if (status !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                && status !== PJQ.constants.integrations.erp.syncStatuses.APPROVED
                && minModified > new Date(exObj.lastSync)) {
                return PJQ.constants.integrations.erp.syncStatuses.STALE;
            }
            return status;
        }
        return 0;
    },
    unlinkERP: function (callback) {
        if (!this.id || this.id === 0) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: `/erp/vendors/${this.id}/unlink`,
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    }
});

PJQ.models.contacts.Contact = PJQ.models.contacts.Company.extend({
    defaults: {
        type: 'contact'
    },
    endpoint: function (options) {
        let params = [];
        if (options) {
            if (options.approve) {
                params.push({
                    parameter: 'approve',
                    value: true
                });
            }
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.id
            }
        ], params)
    },
    sendPasswordReset: function (callback) {
        PJQ.helpers.users.sendPasswordReset(this.get('username'), function (result) {
            if (typeof callback === 'function') {
                callback(result);
            }
        });
    },
    parseContactData: function (model) {
        if (model != null) {
            let isCompanyUser = (this instanceof PJQ.models.users.User || this.id < 0);
            if (PJQ.app.session != null) {
                if (model.userTypeId != null) {
                    this.userType = PJQ.app.session.userTypes.get(model.userTypeId);
                }

                if (this.userType == null) {
                    if (isCompanyUser || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE)) {
                        this.userType = PJQ.app.session.userTypes.getDefault(isCompanyUser);

                        if (this.userType != null)
                            model.userTypeId = this.userType.id;

                    }
                }
            }

            if (model.user != null) {
                this.user = new PJQ.models.users.User(model.user);
            }

            if (this.approvals == null) {
                this.approvalUpdates = new PJQ.collections.contacts.ApprovalUpdates(model.approvalUpdates)
            }

            if (this.groups == null) {
                this.groups = new PJQ.collections.groups.Groups(model.groups, {
                    groupLevels: PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS)
                });
            } else {
                //Override for groups being returned in a nested object
                //This is some old api stuff that will soon be deprecated
                //We will remove this when that happens
                if (model.groups != null) {
                    model.groups = model.groups;
                }
                this.groups.reset(_.size(model.groups) > 0 ? model.groups : null);
                this.groups.options.groupLevels = PJQ.app.session ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS) : 1;
            }

            if (this.workAreas) {
                this.workAreas.reset(model.workAreas);
            } else {
                this.workAreas = new PJQ.collections.workAreas.ContactWorkAreas(model.workAreas, {
                    contactId: model.id
                });
            }
        } else {
            let isCompanyUser = (this instanceof PJQ.models.users.User || this.id < 0);

            if (isCompanyUser || !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE)) {
                this.userType = PJQ.app.session != null ? PJQ.app.session.userTypes.getDefault(isCompanyUser) : null;

            }

            this.groups = new PJQ.collections.groups.Groups();
            this.workAreas = new PJQ.collections.workAreas.ContactWorkAreas();
        }
    },
    fetchEditHistory: function (callback) {
        if (this.editHistory == null) {
            this.editHistory = new PJQ.collections.contacts.EditHistory(null, {
                contact: this
            })
        }

        this.editHistory.fetch({
            success: _.bind(function () {
                callback(this.editHistory);
            }, this)
        });
    },
    fetchCompanyERPObject: function (callback) {
        if (this.get('companyExternalObject') == null && !this.companyErpObjectFetched) {
            this.companyErpObjectFetched = true;
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'contacts',
                        value: this.get('contactCompanyId')
                    },
                    {
                        endpoint: 'erpobject'
                    }
                ]),
                isAPIv2: true
            }).get().done(_.bind(function (data) {
                if (data != null) {
                    this.set({
                        companyExternalObject: data
                    }, {
                        silent: true
                    });
                }
                if (typeof callback === 'function') {
                    callback(this.get('companyExternalObject'));
                }
            }, this)).fail(function () {
                if (typeof callback === 'function') {
                    callback(null);
                }
            });
        } else {
            callback(this.get('companyExternalObject'));
        }
    },
    externalId: function (forCompany = false) {
        let exObj;
        if (forCompany) {
            exObj = this.get('companyExternalObject');
        } else {
            exObj = this.get('externalObject');
        }
        return exObj != null && typeof exObj.externalId === 'string' ? exObj.externalId : null;
    },
    erpSyncStatus: function (forCompany = false) {
        let exObj;
        if (forCompany) {
            exObj = this.get('companyExternalObject');
        } else {
            exObj = this.get('externalObject');
        }
        if (exObj != null) {
            let status = typeof exObj.status === 'number' ? exObj.status : 0;
            if (status !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                && status !== PJQ.constants.integrations.erp.syncStatuses.APPROVED
                && new Date(this.get('modifiedOn')) > new Date(exObj.lastSync)) {
                return PJQ.constants.integrations.erp.syncStatuses.STALE;
            }
            return status;
        }
        return 0;
    },
    isERPSynced: function (forCompany = false) {
        return _.size(this.externalId(forCompany)) > 0;
    },
    fetchSystemPermissions: function (callback) {
        let perm;
        if (!this.isNew()) {
            perm = new PJQ.models.permissions.SystemPermissions({
                id: this.get('id')
            });
        } else {
            perm = new PJQ.models.permissions.SystemPermissions({
                userTypeId: this.userType != null ? this.userType.id : null
            });
        }
        perm.fetch({
            success: _.bind(function () {
                callback(perm);
            }, this)
        });
    },
    fetchProjectPermissions: function (projectId = null, callback) {
        let perm;
        if (!this.isNew()) {
            perm = new PJQ.models.permissions.ProjectPermissions({
                id: this.get('id'),
                projectId: projectId
            });
        } else {
            perm = new PJQ.models.permissions.ProjectPermissions({
                userTypeId: this.userType != null ? this.userType.id : null
            });
        }
        perm.fetch({
            success: _.bind(function () {
                callback(perm);
            }, this)
        });
    },
    fetchSystemNotificationSettings: function (callback) {
        let notificationSettings = null;
        if (!this.isNew()) {
            notificationSettings = new PJQ.models.notificationSettings.SystemNotificationSettings({
                id: this.get('id')
            });
        } else {
            notificationSettings = new PJQ.models.notificationSettings.SystemNotificationSettings({
                userTypeId: this.get('userTypeId')
            });
        }

        notificationSettings.fetch({
            success: _.bind(function () {
                callback(notificationSettings);
            }, this)
        });
    },
    fetchProjectNotificationSettings: function (projectId, callback) {
        let notificationSettings = null;
        if (!this.isNew()) {
            notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
                id: this.get('id'),
                projectId: projectId
            });
        } else {
            notificationSettings = new PJQ.models.notificationSettings.ProjectNotificationSettings({
                userTypeId: this.get('userTypeId'),
                projectId: projectId
            });
        }

        notificationSettings.fetch({
            success: _.bind(function () {
                callback(notificationSettings);
            }, this)
        });
    },
    unlinkUser: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.id
                },
                {
                    endpoint: 'user'
                }
            ])
        }).delete().done(_.bind(function () {
            this.userid = null;
            this.username = null;
            this.user = null;
            if (typeof callback === 'function') {
                callback();
            }
        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    },
    copyContact: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.id
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (model) {
            if (typeof callback === 'function') {
                callback(model);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {

        }, this));
    },
    getVcard: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.id
            },
            {
                endpoint: 'vcard'
            }
        ]));
    },
    showProjectHistory: function () {
        new PJQ.views.projects.ProjectParticipantHistoryModal({
            contactId: this.get('contactId')
        });
    },
    sendUpdater: function (callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('contactId')
                },
                {
                    endpoint: 'updater'
                }
            ])
        }).post().done(_.bind(function () {
            callback();
        }, this)).fail(function (xhr, err, result) {
        });
    },
    exportExcel: function () {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.id
            },
            {
                endpoint: 'export'
            }
        ]));
    },
    beforeSave: function () {
        let flatCustomFields = this.get('contactCustomFieldValuesFlat');
        if (_.size(flatCustomFields) > 0) {
            let parsed = [];
            _.each(flatCustomFields, function (number, value) {
                parsed.push({
                    fieldNumber: number,
                    value: value
                });
            });
            this.set({
                contactCustomFieldValues: parsed,
                contactCustomFieldValuesFlat: null
            })
        }

        let flatCompanyCustomFields = this.get('companyCustomFieldValuesFlat');
        if (_.size(flatCompanyCustomFields) > 0) {
            let parsed = [];
            _.each(flatCompanyCustomFields, function (value, id) {
                parsed.push({
                    id: id,
                    value: value
                });
            });
            this.set({
                companyCustomFieldValues: parsed,
                contactCustomFieldValuesFlat: null
            })
        }

        if (this.groups) {
            this.set({
                groups: _.map(this.groups.models, function (group) {
                    return {
                        groupId: group.id,
                        isDeleted: group.get('isDeleted')
                    }
                })
            });
        }

        if (this.workAreas) {
            this.set({
                workAreas: _.map(this.workAreas.models, function (workArea) {
                    return {
                        contactWorkAreaId: workArea.id,
                        workAreaId: workArea.get('workAreaId'),
                        isDeleted: workArea.get('isDeleted')
                    }
                })
            });
        }

        if (this.userType != null) {
            this.set('userTypeId', this.userType.id);
        }
    },
    approve: function (callback) {
        this.set('approvalUpdates', this.approvalUpdates ? this.approvalUpdates.toJSON() : null);
        this.save(null, {
            urlOptions: {
                approve: true
            },
            success: _.bind(function () {
                this.set('isApprovalRequired', false);
                callback();
            }, this),
            error: _.bind(callback, this)
        });
    },
    addCompanyCustomFieldValue: function (value) {
        this.attributes.companyCustomFieldValues = _.filter(this.attributes.companyCustomFieldValues, function (exValue) {
            return value.id !== exValue.id;
        });
        this.attributes.companyCustomFieldValues.push(value);
    },
    addContactCustomFieldValue: function () {
        this.attributes.contactCustomFieldValues = _.filter(this.attributes.contactCustomFieldValues, function (exValue) {
            return value.id !== exValue.id;
        });
        this.attributes.contactCustomFieldValues.push(value);
    },
    mergeCustomFields: function () {

    }
});

PJQ.models.contacts.EditHistoryItem = PJQ.models.BaseModel.extend({
    idAttribute: 'auditId'
});

PJQ.models.contacts.ApprovalUpdates = PJQ.models.BaseModel.extend({
    idAttribute: 'id'
});

PJQ.models.contacts.ContactCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'contactcustomfields',
                value: this.id
            }
        ])
    }
});

PJQ.models.contacts.CompanyCustomField = PJQ.models.customFields.CustomField.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'companycustomfields',
                value: this.id
            }
        ]);
    },
});

PJQ.models.contacts.CompanyPhoto = PJQ.models.BaseModel.extend({
    idAttribute: 'companyPhotoId',
    endpoint: function () {
        if (_.size(this.get('profileKey')) > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'profiles',
                    value: this.get('profileKey')
                },
                {
                    endpoint: 'companyphotos',
                    value: this.id
                }
            ])
        } else if (this.get('contactCompanyId') > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.get('contactCompanyId')
                },
                {
                    endpoint: 'photos',
                    value: this.id
                }
            ])
        }
    }
});

PJQ.models.contacts.ContactFieldSetting = PJQ.models.BaseModel.extend({
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'fields'
            }
        ]);
    }
});

PJQ.models.contacts.ContactGroup = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'groupId'
});

//Collections
PJQ.collections.contacts.ContactFieldSettings = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactFieldSetting,
    endpoint: function () {
        let params;
        if (this.options.masterUserId > 0) {
            params = [
                {
                    parameter: 'masterUserId',
                    value: this.options.masterUserId
                }
            ];
        } else {
            params = null;
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'fields'
            }
        ], params)
    }
});

PJQ.collections.contacts.Contacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.Contact,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            }
        ]);
    },
    filteredByGroups: function (filter) {
        let groupContacts = PJQ.collections.contacts.Contacts();
        _.each(this.models, function (model) {
            if (model.checkHasGroup(filter))
                groupContacts.add(model);
        });
        return groupContacts;
    }
});

PJQ.collections.contacts.ContactInfoList = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.Contact,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'list'
            }
        ], [
            {
                parameter: 'contactIds',
                value: this.options.contactIds
            }
        ]);
    }
});

PJQ.collections.contacts.EditHistory = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.EditHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.options.contact.id
            },
            {
                endpoint: 'edithistory'
            }
        ]);
    }
});

PJQ.collections.contacts.CompanyPhotos = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.CompanyPhoto,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactCompanyId')
            },
            {
                endpoint: 'photos'
            }
        ]);
    }
});

PJQ.collections.contacts.ContactCustomFields = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ContactCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts'
            },
            {
                endpoint: 'contactcustomfields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

PJQ.collections.contacts.CompanyCustomFields = PJQ.collections.customFields.CustomFields.extend({
    model: PJQ.models.contacts.CompanyCustomField,
    options: {
        masterUserId: null
    },
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
            },
            {
                endpoint: 'companycustomfields'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
            }
        ]);
    }
});

PJQ.collections.contacts.ApprovalUpdates = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.contacts.ApprovalUpdates
})

PJQ.collections.contacts.ContactGroups = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.contacts.ContactGroup,
    endpoint: function () {
        let params = [];
        if (this.options.projectId)
            params.push({
                parameter: 'projectId',
                value: this.options.projectId
            });
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.options.contactId
            },
            {
                endpoint: 'groups'
            }
        ], params);
    }
});
//Views
PJQ.views.contacts.BaseEditContactView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'contact-edit-base'),
        subTemplates: {
            sso: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'user-edit-sso'),
        },
        canEdit: true,
        alert: null,
        onSave: null,
        onCancel: null,
        onDelete: null
    },
    events: {
        "click .btn-edit-permissions": "editPermissions",
        "click .btn-edit-notifications": "editNotifications",
        "change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
        "keydown .contact-edit-phone-ext": "numbersOnly",
        "keyup .contact-edit-phone-ext": "numbersOnly",
        "click .btn-unlock-user": "unlockUser",
        'click .btn-unlink-user': 'unlinkContactUser',
        'click .btn-send-user-reg': 'sendSignUp',
        "click .btn-send-password-reset": "sendPasswordReset",
        "click .btn-screening-request-contact": "newScreeningRequest",
        "click .contact-edit-add": "addNew",
        "click .contact-edit-cancel": "cancel",
        "click .contact-edit-save": "save",
        "click .contact-edit-save-and-add-project": "saveAndAddToProject",
        "click .contact-edit-delete": "delete",
        "change .cb-sso-enabled": "userSSOChanged"
    },
    beforeFirstRender: function () {
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        let prefs = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences,
            isUser = this.model && (this.model.get('id') < 0 || this.model instanceof PJQ.models.users.User);

        if (!this.options.fieldSettingsEnabled) {
            if (isUser) {
                this.options.fieldSettingsEnabled = prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_USER_FIELD_SETTINGS);
            } else {
                this.options.fieldSettingsEnabled = prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
            }
        }

        if (!(this.options.masterUserId > 0)) {
            if (this.options.project != null) {
                this.options.masterUserId = this.options.project.get('masterUserId');
            }
        }

        let fetchContact = (callback) => {
                if (this.model == null) {
                    this.model = new PJQ.models.contacts.Contact({
                        id: this.options.contactId,
                        country: "US"
                    });
                } else if (_.size(this.model.get('country')) === 0) {
                    this.model.set('country', 'US');
                }

                if (!this.model.isNew() && !this.model.isFetched) {
                    this.model.fetch({
                        success: _.bind(function () {
                            this.listenTo(this.model, 'sync', this.render);
                            callback();
                        }, this)
                    });
                } else {
                    this.listenTo(this.model, 'sync', this.render);
                    callback();
                }
            },
            fetchERP = (callback) => {
                PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
                    this.erpIntegration = erp;
                    if (this.erpIntegration != null) {
                        this.model.fetchCompanyERPObject(_.bind(function () {
                            callback();
                        }, this));
                    } else {
                        callback();
                    }
                }, this));
            },
            fnRender = () => {
                if (isUser) {
                    PJQ.app.session.fetchUserCustomFields(this.options.masterUserId, _.bind(function (userCustomFields) {
                        this.userCustomFields = userCustomFields;
                        PJQ.app.session.fetchSSOProviders(_.bind(function (providers) {
                            this.ssoProviders = providers;
                            this.render();
                        }, this));
                    }, this));
                } else {
                    this.render();
                    PJQ.app.session.fetchCompanyCustomFields(this.options.masterUserId, _.bind(function (customFields) {
                        this.companyCustomFields = customFields;
                        if (this.isRendered) {
                            this.renderCompanyCustomFields();
                        }
                    }, this));
                    PJQ.app.session.fetchContactCustomFields(this.options.masterUserId, _.bind(function (customFields) {
                        this.contactCustomFields = customFields;
                        if (this.isRendered) {
                            this.renderContactCustomFields();
                        }
                    }, this));
                }
            };

        fetchContact(() => {
            fetchERP(() => {
                if (this.options.fieldSettingsEnabled) {
                    if (isUser) {
                        PJQ.app.session.fetchUserFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                            this.coreFieldSettings = settings;
                            fnRender();
                        }, this));
                    } else {
                        PJQ.app.session.fetchContactFieldSettings(this.options.masterUserId, _.bind(function (settings) {
                            this.coreFieldSettings = settings;
                            fnRender();
                        }, this));
                    }
                } else {
                    fnRender();
                }
            });
        })
    },
    beforeRender: function () {
        let mod = this.company != null ? this.company : this.model;
        if (mod == null || (this.options.fieldSettingsEnabled && this.coreFieldSettings == null)) {
            return false;
        }

        this.initPermissionOptions();
        this.initViewOptions();

        this.listenTo(mod, 'change:isActive', function () {
            this.render();
        });

        this.listenTo(mod, 'change:itbUser change:pmUser', function () {
            this.featuresDidChange = true;
        });
        this.featuresDidChange = false;

        this.options.showScreenings = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCREENINGS);
    },
    renderERP: function () {
        let company;
        if (this.company != null) {
            company = this.company;
        } else {
            company = this.model;
        }

        let isUser = ((company instanceof PJQ.models.users.User) || (company instanceof PJQ.models.projectContacts.ProjectContact && this.model.id < 0));
        if (this.erpIntegration == null || isUser) {
            return;
        }

        let $modal = this.$el.closest('.modal-content');
        $modal.find('.erp-badge').html(PJQ.helpers.erp.getERPBadge(company.erpSyncStatus(), company.get('externalObject')));
        PJQ.helpers.erp.renderERPButtons($modal.find('.erp-sync'), {
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_VENDORS),
            status: company.erpSyncStatus(true),
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_VENDOR),
        });
        $modal.find('.btn-push-erp').off().on('click', () => this.pushERP());
        $modal.find('.btn-undo-push-erp').off().on('click', () => this.undoPushERP());
        $modal.find('.btn-unlink-erp').off().on('click', () => this.unlinkERP());
    },
    pushERP: async function () {
        if (this.erpIntegration == null || !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_VENDORS)) {
            return;
        }

        let mod = this.company != null ? this.company : this.model,
            fnPush = () => {
                this.erpIntegration.pushVendor(mod, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Company pushed to ERP'
                    });
                    this.render();
                });
            };

        if (mod.isNew()) {
            this.save(() => {
                fnPush();
            });
        } else {
            fnPush();
        }
    },
    undoPushERP: function () {
        let mod = this.company != null ? this.company : this.model;
        if (this.erpIntegration == null || mod.erpSyncStatus() !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            return;
        }

        this.erpIntegration.undoPush(mod, () => {
            PJQ.notifications.notify.successNotify({
                message: 'Company removed from ERP approval'
            });
            this.render();
        });
    },
    unlinkERP: function () {
        if (this.erpIntegration == null) {
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Company from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content')),
                    mod = this.company != null ? this.company : this.model;
                this.erpIntegration.unlinkVendor(mod, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Company unlinked from ERP'
                        });
                        this.render();
                    }
                });
            }
        });
    },
    initViewOptions: function () {
        let mod = this.company != null ? this.company : this.model;
        this.options.groupLevels = null;
        this.options.maxGroups = null;
        if (PJQ.app.session.project != null) {
            // in a project/contact context, all contacts must have a Contact Name and a Phone, to match with old system logic per Bart.
            if (mod.id > 0) {
                this.options.allowMultipleEmails = !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.SUB_RESTRICT_SINGLE_EMAIL);
            }

            // if this is a contact editing their own contact record
            if (!this.options.isAdmin) {
                if (mod.id > 0 && this.options.isSelfEdit) {
                    this.options.allowMultipleEmails = !PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.SUB_RESTRICT_SINGLE_EMAIL);
                }
            }

            this.options.prevailingWageLabel = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PREVAILING_WAGE_LABEL);

            this.options.groupLevels = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS);
            this.options.maxGroups = PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT);
        } else {
            this.options.prevailingWageLabel = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PREVAILING_WAGE_LABEL);
            this.options.groupLevels = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS);
            this.options.maxGroups = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT);
        }

        if (this.options.isAdmin && !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP)) {
            this.options.maxGroups = null;
        }
    },
    initPermissionOptions: function () {
        this.options.enablePermissions = true;

        let mod = this.company != null ? this.company : this.model;
        this.options.isSelfEdit = false;
        this.options.canModifyAttachments = false;
        if (!mod.isNew()) {
            let sessionUserId = PJQ.app.session.user != null ? PJQ.app.session.user.id : null,
                sessionContactId = PJQ.app.session.contact != null ? PJQ.app.session.contact.id : null;
            if (((sessionUserId != null && mod.get('userId') === sessionUserId)) ||
                (sessionContactId != null && mod.get('contactId') === sessionContactId)) {
                this.options.isSelfEdit = true;
            }

            if (mod.id > 0)
                this.options.canModifyAttachments = PJQ.app.session.hasPermission('contacts.canViewAttachments');
        }

        this.options.isAdmin = false;
        this.options.isPrequalVisible = false;
        this.options.canEdit = false;
        this.options.canModifyNotifications = false;
        this.options.canViewCustomFields = true;
        this.options.canEditCustomFields = false;
        let isUser = ((mod instanceof PJQ.models.users.User) || (mod instanceof PJQ.models.projectContacts.ProjectContact && mod.id < 0));
        if (mod.isNew()) {
            this.options.canEdit = true;
            this.options.canEditCustomFields = true;
            this.options.isAdmin = PJQ.app.session.get('masterUserId') > 0;
            this.options.canModifyNotifications = this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
            this.options.canModifyAttachments = !isUser && PJQ.app.session.hasPermission('contacts.canViewAttachments');
        } else if (this.options.isSelfEdit) {
            this.options.canEdit = true;
            this.options.canEditCustomFields = true;
            this.options.isAdmin = PJQ.app.session.hasPermission('settings.canManageUsers') && (PJQ.app.session.user != null && mod.get('masterUserId') === PJQ.app.session.user.get('masterUserId'));
            this.options.canModifyNotifications = this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
        } else if ((((isUser || mod.id < 0) && PJQ.app.session.hasPermission('settings.canManageUsers'))
                || (mod.id > 0 && PJQ.app.session.hasPermission('contacts.isAdmin')) || (mod.id > 0 && PJQ.app.session.hasPermission('contacts.canEditContact')))
            && mod.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
            this.options.canEdit = true;
            this.options.canViewCustomFields = mod.get('masterUserId') === PJQ.app.session.get('masterUserId');
            this.options.canEditCustomFields = true;
            this.options.isAdmin = (this.options.project == null || this.options.project.hasPermission('projectContacts.isAdmin')) && mod.get('masterUserId') === PJQ.app.session.get('masterUserId');
            this.options.isPrequalVisible = !isUser && mod.get('masterUserId') === PJQ.app.session.get('masterUserId') && PJQ.app.session.hasPermission('prequal.canView');
            this.options.canModifyNotifications = this.options.isAdmin && PJQ.app.session.hasPermission('users.canModifyNotifications');
        } else if (mod.get('masterUserId') === 39) {
            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY_EDIT)) {
                this.options.canEdit = true;
            }
            this.options.canEditCustomFields = true;
        }
        this.options.isPrequalVisible = !mod.isNew() && !this.options.isSelfEdit && !isUser && mod.get('masterUserId') === PJQ.app.session.get('masterUserId') && PJQ.app.session.hasPermission('prequal.canView');

        this.options.isCompanyUser = mod instanceof PJQ.models.users.User || mod.id < 0;
    },
    renderData: function () {
        return {
            isContact: this.model.get('id') > 0 || (this.model.isNew() && !(this.model instanceof PJQ.models.users.User)),
            isUser: this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User)),
            model: this.model,
            userTypes: PJQ.app.session.userTypes.getByIsCompany(this.options.isCompanyUser),
            isUserTypeRequired: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE) && this.options.isCompanyUser,
            prevailingWageLabel: this.options.prevailingWageLabel,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            maxGroups: this.options.maxGroups ? this.options.maxGroups : 0,
            isSelfEdit: this.options.isSelfEdit,
            alert: this.options.alert,
            enablePermissions: this.options.enablePermissions,
            canEdit: this.options.canEdit,
            canViewCustomFields: this.options.canViewCustomFields,
            canEditCustomFields: this.options.canEditCustomFields,
            ssoProviders: this.ssoProviders,
            isAdmin: this.options.isAdmin,
            isPrequalVisible: this.options.isPrequalVisible,
            canModifyNotifications: this.options.canModifyNotifications,
            canModifyAttachments: this.options.canModifyAttachments,
            userCustomFields: this.userCustomFields,
            showScreenings: this.options.showScreenings
        };
    },
    afterRender: function () {
        if (this.model == null || (!this.model.isFetched && !this.model.isNew())) {
            new PJQ.Loader(this.$('.modal-body'));
        } else {
            if (this.options.masterUserId == null) {
                this.options.masterUserId = this.model.get('masterUserId');
            }
            this.renderERP();
            this.renderContact();
        }
    },
    checkFieldRequired: function (fieldName) {
        if (!this.checkFieldVisible(fieldName) || !this.options.canEdit) {
            return false;
        }

        if (!this.options.isSelfEdit && fieldName === 'userType')
            return true;

        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            switch (fieldName) {
                case 'contactName':
                case 'email':
                    return true;
                case 'address1':
                case 'address2':
                case 'city':
                case 'state':
                    return false;
                case 'country':
                    return (!this.options.isAdmin && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ADDRESS_REQUIRED)) ||
                        (this.options.isAdmin && (prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE) || ((prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP) && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ADDRESS_REQUIRED)))));
                case 'zip':
                    return (!this.options.isAdmin && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ZIP_REQUIRED)) ||
                        (this.options.isAdmin && (prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE) || ((prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP) && prefs.hasPref(PJQ.constants.preferenceTypes.SUB_ZIP_REQUIRED)))));
                case 'phone':
                    return !this.options.isAdmin ||
                        prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_CORE) ||
                        (prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP) && prefs.hasPref(PJQ.constants.preferenceTypes.DOWNLOAD_CONTACT_UPDATE_REQ));
                case 'laborStatus':
                    return this.checkFieldVisible(fieldName) && !prefs.hasPref(PJQ.constants.preferenceTypes.NO_REQUIRE_UNION_SUB) &&
                        (!this.options.isAdmin || prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP));
                case 'groups':
                    let isUser = (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User)));
                    if (isUser) {
                        return false;
                    }
                    return prefs.hasPref(PJQ.constants.preferenceTypes.ALLOW_SUB_GROUP_EDIT_REQUIRED) &&
                        (this.options.isSelfEdit || prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_ENABLE_ADMIN_REQUIRED_FIELDS_RSVP));
            }
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return !this.options.isAdmin ? fieldSettings.get('isRequiredContact') : fieldSettings.get('isRequiredAdmin');
            }
        }
        return false;
    },
    checkFieldVisible: function (fieldName) {
        // special fields
        if (fieldName === 'title' && (this.model == null ? false : (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User))))) {
            return false;
        } else if (this.options.isSelfEdit && (fieldName === 'userType' || fieldName === 'companyNotes' || fieldName === 'contactNotes' || fieldName === 'active')) {
            return false;
        } else if (!this.options.isSelfEdit && fieldName === 'userType') {
            return true;
        }

        if (this.coreFieldSettings == null) {
            let prefs;
            if (PJQ.app.session.project != null) {
                prefs = PJQ.app.session.project.preferences;
            } else {
                prefs = PJQ.app.session.preferences;
            }
            let result;
            switch (fieldName) {
                case 'sector':
                    result = !prefs.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_SECTOR);
                    break;
                case 'laborStatus':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
                    if (!this.options.isAdmin) {
                        if (result && prefs.hasPref(PJQ.constants.preferenceTypes.CAN_EDIT_UNION_STATUS_SUB)) {
                            result = prefs.getPref(PJQ.constants.preferenceTypes.CAN_EDIT_UNION_STATUS_SUB);
                        }
                    }
                    break;
                case 'classifications':
                    result = prefs.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_HIDE_MINORITY_STATUS) === false &&
                        (this.options.isAdmin || prefs.getPref(PJQ.constants.preferenceTypes.CAN_EDIT_MINORITY_CLASS_SUB));
                    break;
                case 'groups':
                    result = !(this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User)));
                    break;
                default:
                    result = true;
            }
            return result;
        } else {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return this.options.isSelfEdit ? fieldSettings.get('isVisibleContact') : fieldSettings.get('isVisibleAdmin');
            }
        }
        return true;
    },
    renderContact: function () {
        if (this.checkFieldVisible('userType') !== false) {
            let isCompanyUser = (this.model instanceof PJQ.models.users.User || this.model.id < 0),
                defaultUserType = (!isCompanyUser && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE)) ? null : (this.model.get('userTypeId') != null ? this.model.get('userTypeId') : null);
            this.userTypePicker = new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-user-type'),
                noneSelectedText: 'Select Value',
                isIntChoices: true,
                defaultValue: this.model.userType ? this.model.userType.id : defaultUserType,
                onChange: _.bind(function (value) {
                    this.model.set('userTypeId', value);
                    this.model.userType = PJQ.app.session.userTypes.getById(value);
                }, this)
            });
        }

        let statePicker = new PJQ.inputs.StatePicker({
            el: this.$('.contact-edit-state'),
            country: this.model.get('country') ?? null,
            defaultValue: this.model.get('state') ?? null,
            size: 20,
            onChange: (value) => {
                this.model.set('state', value);
            }
        });

        new PJQ.inputs.CountryPicker({
            el: this.$('.contact-edit-country'),
            defaultValue: this.model.get('country') ?? null,
            statePicker: statePicker,
            zipInput: this.$('.contact-edit-zip'),
            enableInternational: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_INTERNATIONAL_COUNTRIES),
            size: 20,
            onChange: (value) => {
                this.model.set('country', value);
            }
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.contact-edit-selection-status'),
            noneSelectedText: 'Select Value',
            defaultValue: this.model.get('isAutoSelectDisabled'),
            onChange: _.bind(function (value) {
                this.model.set('isAutoSelectDisabled', value === "true");
            }, this)
        });

        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model);
        }

        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-phone'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-fax'));
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.contact-edit-cell'));

        this.renderLaborStatus(this.model);
        this.renderSector(this.model);
        this.renderMinority(this.model);

        if (this.$('#contactInfoCollapseContainer').length > 0) {
            new PJQ.views.collapse.BaseCollapse({
                el: this.$('#contactInfoCollapseContainer'),
                onShown: _.bind(function (id) {
                    switch (id) {
                        case 'prequalCollapse':
                            this.renderPrequal();
                            break;
                        case 'screeningCollapse':
                            this.renderScreenings();
                            break;
                        case 'contactEditWorkAreasCollapse':
                            if (this.workAreaMap == null || this.workAreaMap.options.contactId !== this.model.id) {
                                if (this.model.workAreas != null) {
                                    this.renderWorkAreas();
                                }
                            } else {
                                this.workAreaMap.refresh();
                            }
                            break;
                        case 'companyAttachmentsCollapse':
                            this.renderCompanyAttachments();
                            break;
                    }
                }, this)
            });
        } else {
            this.renderWorkAreas();
        }

        if (!(this.model instanceof PJQ.models.users.User) && (this.model.id > 0 || this.model.isNew())) {
            if (this.model.groups != null) {
                this.renderGroupSelector();
            }

            if (this.options.canViewCustomFields) {
                this.renderCompanyCustomFields();
                this.renderContactCustomFields();
            }
        }


        if (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User))) {

            if (this.model.groups != null && this.checkFieldVisible('groups'))
                this.renderGroupSelector();

            if (this.options.canViewCustomFields) {
                this.renderUserCustomFields();
            }
            if (this.options.isAdmin) {
                this.renderSSO();
            }
        }

        this.isRendered = true;
    },
    renderPrequal: function () {
        if (!PJQ.app.session.hasPermission('prequal.canView') || !PJQ.app.session.subscription.hasFeature('projectmessaging')) {
            // this element shouldn't even be rendered if the user doesn't meet this criteria
            // but we remove it just for good measure
            this.$('.prequal-section').remove();
            return;
        }

        if (this.prequalEditor != null) {
            return;
        }

        let contact;
        if (!this.model.isNew()) {
            contact = this.model.clone();
        } else {
            contact = _.find(this.company.contacts.models, function (compContact) {
                return compContact.id > 0;
            });
        }
        if (contact != null) {
            let self = this,
                mod = this.company != null ? this.company : this.model;
            let fnRender = function () {
                PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Screening-Editor-Dashboard'), self.$('.company-prequal-data'), {
                    prequal: mod.prequal,
                    isAdmin: self.options.isAdmin,
                    isPrequalVisible: self.options.isPrequalVisible
                }, function ($outer) {
                    self.$('.company-prequal-data .prequal-export-pdf').click(function () {
                        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: contact.get('contactId')
                            },
                            {
                                endpoint: 'prequal'
                            },
                            {
                                endpoint: 'export'
                            }
                        ], [
                            {
                                parameter: 'masterUserId',
                                value: mod.prequal.get('masterUserId') > 0 ? mod.prequal.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                            },
                            {
                                parameter: 'isExcel',
                                value: false
                            }
                        ]));
                    });

                    self.$('.company-prequal-data .prequal-export-excel').click(function () {
                        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'contacts',
                                value: contact.get('contactId')
                            },
                            {
                                endpoint: 'prequal'
                            },
                            {
                                endpoint: 'export'
                            }
                        ], [
                            {
                                parameter: 'masterUserId',
                                value: mod.prequal.get('masterUserId') > 0 ? mod.prequal.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                            },
                            {
                                parameter: 'isExcel',
                                value: true
                            }
                        ]));
                    });

                    self.prequalEditor = new PJQ.views.prequal.PrequalEditor({
                        el: $outer.find('.screening-dashboard-body'),
                        isAdmin: self.model.get('masterUserId') === PJQ.app.session.user.get('masterUserId'),
                        canEdit: PJQ.app.session.hasPermission('prequal.canEdit'),
                        clients: new PJQ.collections.screenings.ScreeningClients(),
                        navContainer: $outer.find('.screening-dashboard-nav-extend'),
                        preferences: PJQ.app.session.preferences,
                        model: mod.prequal,
                        contact: contact,
                        onContactChange: function (contact, ch) {
                            if (contact.id === self.model.id) {
                                self.model.groups = contact.groups;
                                self.model.workAreas = contact.workAreas;
                                self.model.set(ch.prop, ch.value);
                                mod.set(ch.prop, ch.value);
                                self.renderContact();
                            }
                        },
                        onCompanyCustomFieldChange: function (ch) {
                            if (self.companyCustomFieldsForm != null && ch != null && ch.id > 0) {
                                _.each(self.model.attributes.companyCustomFieldValues, function (cfv) {
                                    if (cfv.id === ch.id) {
                                        cfv.value = ch.value;
                                    }
                                });

                                self.companyCustomFieldsForm.setValue(ch.id, ch.value);
                            }
                        },
                        onContactCustomFieldChange: function (ch) {
                            if (self.contactCustomFieldsForm != null && ch != null && ch.id > 0) {
                                _.each(self.model.attributes.contactCustomFieldValues, function (cfv) {
                                    if (cfv.id === ch.id) {
                                        cfv.value = ch.value;
                                    }
                                });

                                self.contactCustomFieldsForm.setValue(ch.id, ch.value);
                            }
                        }
                    });
                });
            };
            if (mod.prequal == null || !mod.prequal.isFetched) {
                mod.prequal = new PJQ.models.prequal.Prequal({
                    contact: contact
                });
                mod.prequal.fetch({
                    success: function () {
                        fnRender();
                    }
                });
            } else {
                mod.prequal.contact = contact;
                fnRender();
            }
        }
    },
    renderScreenings: function () {
        if (!this.options.isAdmin) {
            // this element shouldn't even be rendered if the user isnt an admin
            // but we remove it just for good measure
            this.$('.screening-section').remove();
            return;
        }

        let contactId = null;
        if (!this.model.isNew()) {
            contactId = this.model.id;
        } else if (this.company != null) {
            let contact = _.find(this.company.contacts.models, function (compContact) {
                return compContact.id > 0;
            });
            if (contact != null) {
                contactId = contact.id;
            }
        }

        if (this.screenings == null && contactId != null) {
            let self = this;
            this.screenings = new PJQ.models.screenings.ScreeningClient({
                masterUserId: PJQ.app.session.get('masterUserId'),
                contactId: contactId
            });
            this.screenings.fetch({
                success: _.bind(function () {
                    let $screenings = this.$('.contact-screenings');
                    if (_.size(this.screenings.categories) > 0) {
                        this.screeningEditor = new PJQ.views.screenings.ScreeningClientEditor({
                            el: $screenings,
                            canManage: !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROQUAL_CUSTOMER),
                            isAdmin: self.options.isAdmin,
                            model: this.screenings
                        });
                    } else {
                        $screenings.empty();
                        new PJQ.Alert($screenings, {
                            text: 'This contact has not been requested to complete any screening items'
                        });
                    }
                }, this)
            })
        }
    },
    newScreeningRequest: function () {
        new PJQ.views.addressbook.ProqualRequestModal({
            contactId: this.model.id,
            onSend: _.bind(function () {
                this.screenings = null;
                this.renderScreenings();
            }, this)
        });
    },
    renderCompanyAttachments: function () {
        if (!PJQ.app.session.hasPermission('contacts.canViewAttachments')) {
            return;
        }
        if (this.companyAttachmentFileUploader == null) {

            let sortSettings;
            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SORT_COMPANY_ATTACHMENTS))
                sortSettings = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SORT_COMPANY_ATTACHMENTS);

            this.companyAttachmentFileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.company-documents'),
                collection: this.model.attachments,
                sortBy: sortSettings ? sortSettings.sortBy : null,
                sortDirection: sortSettings ? (sortSettings.sortBy ? 'asc' : 'desc') : null,
                // canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                canUpload: PJQ.app.session.hasPermission('contacts.canEditContact'),
                canDownloadAll: true,
                onSuccess: _.bind(function () {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    renderLaborStatus: function (mod) {
        if (this.checkFieldVisible('laborStatus') && mod != null) {
            let laborStatus = [];
            if (mod.get('isUnion')) {
                laborStatus.push('union');
            }
            if (mod.get('isNonUnion')) {
                laborStatus.push('nonUnion');
            }
            if (mod.get('isPrevailingWage')) {
                laborStatus.push('prevWage');
            }

            new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-labor-status'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isDisabled: !this.options.canEdit,
                defaultValue: laborStatus,
                onChange: _.bind(function (value) {
                    mod.set({
                        isUnion: (value?.indexOf("union") ?? -1) !== -1,
                        isNonUnion: (value?.indexOf("nonUnion") ?? -1) !== -1,
                        isPrevailingWage: (value?.indexOf("prevWage") ?? -1) !== -1
                    });

                    //temporary fix for api call on contact overriding the company in the address book
                    // we set this.company to the same as mod (if it exists)
                    if (this.company != null) {
                        this.company.set({
                            isUnion: (value?.indexOf("union") ?? -1) !== -1,
                            isNonUnion: (value?.indexOf("nonUnion") ?? -1) !== -1,
                            isPrevailingWage: (value?.indexOf("prevWage") ?? -1) !== -1
                        });
                    }
                }, this)
            });
        }
    },
    renderSector: function (mod) {
        if (this.checkFieldVisible('sector') && mod != null) {
            let sectors = [];
            if (mod.get('isPrivateSector')) {
                sectors.push('privateSector');
            }
            if (mod.get('isPublicSector')) {
                sectors.push('publicSector');
            }

            new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-sector'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isDisabled: !this.options.canEdit,
                defaultValue: sectors,
                onChange: _.bind(function (value) {
                    mod.set({
                        isPrivateSector: value.indexOf("privateSector") !== -1,
                        isPublicSector: value.indexOf("publicSector") !== -1,
                    });

                    //temporary fix for api call on contact overriding the company in the address book
                    // we set this.company to the same as mod (if it exists)
                    if (this.company != null) {
                        this.company.set({
                            isPrivateSector: value.indexOf("privateSector") !== -1,
                            isPublicSector: value.indexOf("publicSector") !== -1,
                        });
                    }
                }, this)
            });
        }
    },
    renderMinority: function (mod) {
        if (this.checkFieldVisible('classifications') && mod != null) {
            let minorityClass = [];
            if (mod.get('isDBE')) {
                minorityClass.push('isDBE');
            }
            if (mod.get('isDVBE')) {
                minorityClass.push('isDVBE');
            }
            if (mod.get('isMBE')) {
                minorityClass.push('isMBE');
            }
            if (mod.get('isSBE')) {
                minorityClass.push('isSBE');
            }
            if (mod.get('isSDVBE')) {
                minorityClass.push('isSDVBE');
            }
            if (mod.get('isWBE')) {
                minorityClass.push('isWBE');
            }

            if (minorityClass.length === 0)
                minorityClass.push('NA');

            this.minorityClassSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.contact-edit-minority-class'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isDisabled: !this.options.canEdit,
                defaultValue: minorityClass,
                exclusiveChoices: "NA",
                onChange: _.bind(function (value) {
                    mod.set({
                        isDBE: value.indexOf("isDBE") !== -1,
                        isDVBE: value.indexOf("isDVBE") !== -1,
                        isMBE: value.indexOf("isMBE") !== -1,
                        isSBE: value.indexOf("isSBE") !== -1,
                        isSDVBE: value.indexOf("isSDVBE") !== -1,
                        isUDBE: value.indexOf("isUDBE") !== -1,
                        isVSBE: value.indexOf("isVSBE") !== -1,
                        isWBE: value.indexOf("isWBE") !== -1
                    });

                    //temporary fix for api call on contact overriding the company in the address book
                    // we set this.company to the same as mod (if it exists)
                    if (this.company != null) {
                        this.company.set({
                            isDBE: value.indexOf("isDBE") !== -1,
                            isDVBE: value.indexOf("isDVBE") !== -1,
                            isMBE: value.indexOf("isMBE") !== -1,
                            isSBE: value.indexOf("isSBE") !== -1,
                            isSDVBE: value.indexOf("isSDVBE") !== -1,
                            isUDBE: value.indexOf("isUDBE") !== -1,
                            isVSBE: value.indexOf("isVSBE") !== -1,
                            isWBE: value.indexOf("isWBE") !== -1
                        });
                    }
                }, this)
            });
        }
    },
    renderGroupSelector: function () {
        let $groups = this.$('.contact-edit-groups');
        if (_.size($groups) > 0) {
            if (this.groupSelector != null) {
                this.groupSelector.remove();
            }

            this.groupSelector = new PJQ.views.groups.GroupSelector({
                el: this.$('.contact-edit-groups'),
                contactId: this.model != null ? this.model.id : null,
                groupLevels: this.options.groupLevels,
                groupUserId: this.options.masterUserId,
                selectedGroups: this.model.groups,
                maxGroups: this.options.maxGroups,
                detectGroupLevels: this.options.detectGroupLevels,
                isAdmin: this.options.canEdit && !this.options.isSelfEdit && !(PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK) || PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY_EDIT)),
                canEdit: this.options.canEdit,
                onGroupSelected: _.bind(this.groupsChanged, this)
            });
        }
    },
    groupsChanged: function (data) {
        this.model.isDirty = true;
    },
    sendPasswordReset: function () {
        this.model.sendPasswordReset(_.bind(function () {
            let $container = this.$('.btn-send-password-reset').closest('div');
            $container.html('<div class="fs-16 text-success"><i class="fal fa-check mr-1"></i>Password Reset Sent</div>');
        }, this));
    },
    unlinkContactUser: function () {
        if (this.model.user != null) {
            this.model.unlinkUser(_.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'User successfully unlinked from contact'
                });
                this.render();
            }, this));
        }
    },
    sendSignUp: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.model.id
                },
                {
                    endpoint: 'requestsignup'
                },
            ])
        }).post().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Sign up link sent'
            });
            this.$('button.btn-send-user-reg').remove();
            this.$('.sign-up-alert').replaceWith('<div class="fs-16 text-success"><i class="fal fa-check mr-1"></i>Sign-Up Link Sent</div>');
        }, this)).fail(function (xhr, err, result) {

        });
    },
    userSSOChanged: function () {
        this.model.set('isSSOEnabled', this.$('.cb-sso-enabled').prop('checked'));
        this.renderSSO();
    },
    renderSSO: function () {
        if (this.model.get('isSSOEnabled')) {
            this.$('.btn-send-password-reset').addClass('hidden');
        } else {
            this.$('.btn-send-password-reset').removeClass('hidden');
        }
        this.renderSubTemplate(false, this.options.subTemplates.sso, this.$('.user-sso'), {
            model: this.model,
            ssoProviders: this.ssoProviders
        }, _.bind(function () {
            this.tagSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-sso-provider'),
                defaultValue: this.model.get('samlId'),
                noneSelectedText: 'Default Provider',
                isIntChoices: true,
                onChange: _.bind(function (value) {
                    this.model.set('samlId', value);
                }, this)
            });
        }, this));
    },
    renderUserCustomFields: function () {
        let $cf = this.$('.user-custom-fields');
        if (this.userCustomFields != null) {
            if (_.size(this.userCustomFields.models) > 0) {
                this.$('.user-custom-fields-outer').removeClass('hidden');

                let reqField = _.find(this.userCustomFields.models, function (customField) {
                    return customField.get('isRequired');
                }, this);
                if (reqField != null) {
                    this.$('.user-custom-fields-header').html('Additional User Details ' + PJQ.constants.markup.requiredAst);
                }

                let cfArray = [];
                _.each(this.userCustomFields.models, function (field) {
                    let fieldValue = _.find(this.model.get('userCustomFieldValues'), function (cfv) {
                        return cfv && cfv.id === field.get('id');
                    }, this);
                    if (_.size(field.get('defaultValue')) > 0 && (fieldValue == null || fieldValue.value == null || (typeof fieldValue.value !== 'number' && typeof fieldValue.value !== 'boolean' && _.size(fieldValue.value) === 0))) {
                        let defaultValue;
                        switch (field.get('fieldType')) {
                            case 'CHOICE':
                                defaultValue = parseInt(field.get('defaultValue'));
                                break;
                            case 'CHOICEMULTIPLE':
                                defaultValue = parseInt(field.get('defaultValue'));
                                break;
                            case 'BOOL':
                                defaultValue = field.get('defaultValue') === 'true';
                                break;
                            default:
                                defaultValue = field.get('defaultValue');
                                break;
                        }

                        if (fieldValue != null) {
                            fieldValue.value = defaultValue;
                        } else {
                            fieldValue = {
                                id: field.get('id'),
                                fieldNumber: field.get('fieldNumber'),
                                value: defaultValue
                            }
                        }
                    }
                    if (fieldValue != null) {
                        cfArray.push(fieldValue);
                    }
                }, this);
                this.model.set({
                    'userCustomFieldValues': cfArray
                }, {
                    silent: true
                });

                this.userCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                    el: $cf,
                    isAdmin: true,
                    isEdit: this.options.canEdit,
                    collection: this.userCustomFields,
                    model: this.model,
                    fieldValues: this.model.get('userCustomFieldValues'),
                    onChange: _.bind(function () {
                        this.model.isDirty = true;
                    }, this)
                });
            }
        }
    },
    renderCompanyCustomFields: function () {
        let $cf = this.$('.company-custom-fields');
        if (this.companyCustomFields != null && (this.model.id > 0 || this.model.isNew()) && $cf.length > 0) {
            if (_.size(_.filter(this.companyCustomFields.models, _.bind(function (field) {
                return (!this.options.isSelfEdit || field.get('isVisibleInRSVP'));
            }, this))) > 0) {
                this.$('.company-custom-fields-outer').removeClass('hidden');

                let reqField = _.find(this.companyCustomFields.models, function (customField) {
                    return (!this.options.isAdmin && customField.get('isRequired')) || customField.get('isRequiredAdmin');
                }, this);
                if (reqField != null) {
                    this.$('.company-custom-fields-header').html('Additional Company Details ' + PJQ.constants.markup.requiredAst);
                }

                let cfAdmin = PJQ.app.session.user != null && (this.model.get('masterUserId') === PJQ.app.session.user.get('masterUserId') || this.model.isNew());
                if (this.companyCustomFields != null) {
                    let cfArray = [];
                    _.each(this.companyCustomFields.models, function (field) {
                        let fieldValue = _.find(this.model.get('companyCustomFieldValues'), function (cfv) {
                            return cfv && cfv.id === field.get('id');
                        }, this);
                        if (_.size(field.get('defaultValue')) > 0 && (fieldValue == null || fieldValue.value == null || (typeof fieldValue.value !== 'number' && typeof fieldValue.value !== 'boolean' && _.size(fieldValue.value) === 0))) {
                            let defaultValue;
                            switch (field.get('fieldType')) {
                                case 'CHOICE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'CHOICEMULTIPLE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'BOOL':
                                    defaultValue = field.get('defaultValue') === 'true';
                                    break;
                                default:
                                    defaultValue = field.get('defaultValue');
                                    break;
                            }

                            if (fieldValue != null) {
                                fieldValue.value = defaultValue;
                            } else {
                                fieldValue = {
                                    id: field.get('id'),
                                    fieldNumber: field.get('fieldNumber'),
                                    value: defaultValue
                                }
                            }
                        }
                        if (fieldValue != null) {
                            cfArray.push(fieldValue);
                        }
                    }, this);
                    this.model.set({
                        'companyCustomFieldValues': cfArray
                    }, {
                        silent: true
                    });
                }

                this.companyCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                    el: $cf,
                    isAdmin: cfAdmin,
                    isEdit: this.options.canEditCustomFields,
                    collection: this.companyCustomFields,
                    fieldValues: this.model.get('companyCustomFieldValues'),
                    onChange: _.bind(function () {
                        this.model.isDirty = true;
                    }, this)
                });
            }
        }
    },
    renderContactCustomFields: function () {
        let $cf = this.$('.contact-custom-fields');
        if (this.contactCustomFields != null && $cf.length > 0) {
            if (_.size(_.filter(this.contactCustomFields.models, _.bind(function (field) {
                return (!this.options.isSelfEdit || field.get('isVisibleInRSVP'));
            }, this))) > 0) {
                this.$('.contact-custom-fields-outer').removeClass('hidden');

                let reqField = _.find(this.contactCustomFields.models, function (customField) {
                    return (!this.options.isAdmin && customField.get('isRequired')) || customField.get('isRequiredAdmin');
                }, this);
                if (reqField != null) {
                    this.$('.contact-custom-fields-header').html('Additional Contact Details ' + PJQ.constants.markup.requiredAst);
                }

                let cfAdmin = PJQ.app.session.user != null && (this.model.get('masterUserId') === PJQ.app.session.user.get('masterUserId') || this.model.isNew());
                if (this.contactCustomFields != null) {
                    let cfArray = [];
                    _.each(this.contactCustomFields.models, function (field) {
                        let fieldValue = _.find(this.model.get('contactCustomFieldValues'), function (cfv) {
                            return cfv && cfv.id === field.get('id');
                        }, this);
                        if (_.size(field.get('defaultValue')) > 0 && (fieldValue == null || fieldValue.value == null || (typeof fieldValue.value !== 'number' && typeof fieldValue.value !== 'boolean' && _.size(fieldValue.value) === 0))) {
                            let defaultValue;
                            switch (field.get('fieldType')) {
                                case 'CHOICE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'CHOICEMULTIPLE':
                                    defaultValue = parseInt(field.get('defaultValue'));
                                    break;
                                case 'BOOL':
                                    defaultValue = field.get('defaultValue') === 'true';
                                    break;
                                default:
                                    defaultValue = field.get('defaultValue');
                                    break;
                            }

                            if (fieldValue != null) {
                                fieldValue.value = defaultValue;
                            } else {
                                fieldValue = {
                                    id: field.get('id'),
                                    fieldNumber: field.get('fieldNumber'),
                                    value: defaultValue
                                }
                            }
                        }
                        if (fieldValue != null) {
                            cfArray.push(fieldValue);
                        }
                    }, this);
                    this.model.set({
                        'contactCustomFieldValues': cfArray
                    }, {
                        silent: true
                    });
                }

                this.contactCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                    el: $cf,
                    isAdmin: cfAdmin,
                    isEdit: this.options.canEditCustomFields,
                    collection: this.contactCustomFields,
                    fieldValues: this.model.get('contactCustomFieldValues'),
                    onChange: _.bind(function () {
                        this.model.isDirty = true;
                    }, this)
                });
            }
        }
    },
    renderWorkAreas: function () {
        let $workAreas = this.$('.contact-edit-work-areas');
        if (_.size($workAreas) > 0) {
            this.workAreaMap = new PJQ.views.workAreas.WorkAreaMap({
                el: $workAreas,
                collection: this.model.workAreas,
                isInline: false,
                isEdit: this.options.canEdit,
                isSync: false,
                contactId: this.model.id,
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }
    },
    countryChanged: function () {
        let country = this.model.get('country') && this.model.get('country').length > 0 ? this.model.get('country').toLowerCase() : 'us',
            options = '<option value="">Select Value</option>';
        _.each(PJQ.constants.states[country], function (state) {
            options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
        });
        this.statePicker.$el.html(options);
        this.statePicker.refresh();
        if (this.model.get('state'))
            this.statePicker.setValue(this.model.get('state').toLowerCase());

        PJQ.helpers.inputHelpers.inputMaskZip(this.$('.contact-edit-zip'), country);
    },
    formatPhone: function (e) {
        let target = $(e.currentTarget);
        target.val(PJQ.helpers.formatHelpers.formatPhoneNumber(target.val()));
    },
    numbersOnly: function (e) {
        if (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) {
            return true;
        } else {
            return PJQ.helpers.inputHelpers.numbersOnly(e);
        }
    },
    editPermissions: function () {
        new PJQ.views.permissions.PermissionsEditorModal({
            model: this.model,
            project: this.options.project
        });
    },
    editNotifications: function () {
        new PJQ.views.notificationSettings.NotificationSettingsEditorModal({
            model: this.model,
            project: this.options.project
        });
    },
    validateCoreFields: function () {
        let hasError = false,
            $scrollTo = null;
        if (this.checkFieldRequired('companyName')) {
            let $company = this.$('.contact-edit-company');
            if ($company.length > 0) {
                PJQ.helpers.inputHelpers.setInputError($company, true);
                if (_.size(this.model.get('companyName')) === 0) {
                    PJQ.helpers.inputHelpers.setInputError($company, false);
                    hasError = true;
                }
            }
        }

        if (this.checkFieldRequired('contactName')) {
            let $contactName = this.$('.contact-edit-name');
            PJQ.helpers.inputHelpers.setInputError($contactName, true);
            if (_.size(this.$('.contact-edit-name').val()) === 0) {
                PJQ.helpers.inputHelpers.setInputError($contactName, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('title')) {
            let $title = this.$('.contact-edit-title');
            PJQ.helpers.inputHelpers.setInputError($title, true);
            if (_.size(this.model.get('title')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($title, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('phone')) {
            let $phone = this.$('.contact-edit-phone');
            PJQ.helpers.inputHelpers.setInputError($phone, true);
            if (_.size(this.model.get('phone')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($phone, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('cell')) {
            let $cell = this.$('.contact-edit-cell');
            PJQ.helpers.inputHelpers.setInputError($cell, true);
            if (_.size(this.model.get('cell')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($cell, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('fax')) {
            let $fax = this.$('.contact-edit-fax');
            PJQ.helpers.inputHelpers.setInputError($fax, true);
            if (_.size(this.model.get('fax')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($fax, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('email')) {
            let $email = this.$('.contact-edit-email');
            PJQ.helpers.inputHelpers.setInputError($email, true);
            if (_.size(this.model.get('email')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($email, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('address1')) {
            let $add1 = this.$('.contact-edit-address-1');
            PJQ.helpers.inputHelpers.setInputError($add1, true);
            if (_.size(this.model.get('address1')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($add1, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('address2')) {
            let $add2 = this.$('.contact-edit-address-2');
            PJQ.helpers.inputHelpers.setInputError($add2, true);
            if (_.size(this.model.get('address2')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($add2, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('city')) {
            let $city = this.$('.contact-edit-city');
            PJQ.helpers.inputHelpers.setInputError($city, true);
            if (_.size(this.model.get('city')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($city, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('state')) {
            let $state = this.$('.contact-edit-state');
            PJQ.helpers.inputHelpers.setInputError($state, true);
            if (_.size(this.model.get('state')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($state, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('zip')) {
            let $zip = this.$('.contact-edit-zip');
            PJQ.helpers.inputHelpers.setInputError($zip, true);
            if (_.size(this.model.get('zip')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($zip, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('country')) {
            let $country = this.$('.contact-edit-country');
            PJQ.helpers.inputHelpers.setInputError($country, true);
            if (_.size(this.model.get('country')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($country, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('laborStatus') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $union = this.$('.contact-edit-labor-status,.company-edit-labor-status');
            PJQ.helpers.inputHelpers.setInputError($union, true);
            if (!this.model.get('isUnion') && !this.model.get('isNonUnion') && !this.model.get('isPrevailingWage')) {
                PJQ.helpers.inputHelpers.setInputError($union, false);
                hasError = true;
            }
        }

        if (this.checkFieldRequired('classifications') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $certifications = this.$('.contact-edit-minority-class,.contact-edit-minority-class');
            PJQ.helpers.inputHelpers.setInputError($certifications, true);
            if (this.minorityClassSelectPicker.getValue().length == 0)  {
                PJQ.helpers.inputHelpers.setInputError($certifications, false);
                hasError = true;
            }
            
        }

        if (this.checkFieldRequired('sector') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $sector = this.$('.contact-edit-sector,.company-edit-sector');
            PJQ.helpers.inputHelpers.setInputError($sector, true);
            if (!this.model.get('isPublicSector') && !this.model.get('isPrivateSector')) {
                PJQ.helpers.inputHelpers.setInputError($sector, false);
                hasError = true;
            }
        }

        if (this.checkFieldVisible('userType') && !(this.model instanceof PJQ.models.users.User) && (!(this.model instanceof PJQ.models.projectContacts.ProjectContact) || this.model.get('id') > 0)) {
            let $usertype = this.$('.contact-edit-user-type');
            PJQ.helpers.inputHelpers.setInputError($usertype, true);
            if (!this.model.get('userTypeId')) {
                PJQ.helpers.inputHelpers.setInputError($usertype, false);
                hasError = true;
            }
        }

        if (hasError) {
            $scrollTo = this.$('.validation-error')
        }

        if (this.groupSelector != null) {
            this.groupSelector.hideError();
            if (this.checkFieldRequired('groups') && _.size(this.groupSelector.getGroupsData().selected) === 0) {
                this.groupSelector.showError('Please select at least one value');
                hasError = true;

                let $gac = this.$('#contactEditGroupsCollapse');
                if ($gac.length > 0) {
                    if (!$gac.hasClass('show'))
                        $gac.siblings('.card-header').click();

                    if ($scrollTo == null) {
                        $scrollTo = $gac;
                    }
                } else if ($scrollTo == null) {
                    $scrollTo = this.$('.contact-edit-groups');
                }
            }
        }

        if (this.workAreaMap != null) {
            this.workAreaMap.hideError();
            if (this.checkFieldRequired('workAreas') && _.size(_.filter(this.model.workAreas.models, function (workArea) {
                return !workArea.get('isDeleted')
            })) === 0) {
                hasError = true;

                let $wac = this.$('#contactEditWorkAreasCollapse');
                if ($wac.length > 0) {
                    if (!$wac.hasClass('show'))
                        $wac.siblings('.card-header').click();

                    if ($scrollTo == null) {
                        $scrollTo = $wac;
                    }
                } else if ($scrollTo == null) {
                    $scrollTo = this.$('.contact-edit-work-areas');
                }

                this.workAreaMap.showError('Please select at least one work area');
            }
        }

        return {
            valid: !hasError,
            $scrollTo: $scrollTo
        };
    },
    unlockUser: function () {
        this.model.unlock(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'User unlocked'
            });
            this.render();
        }, this));
    },
    saveAndAddToProject: function () {
        this.save(null, false, true);
    },
    save: function (e, isAddNew, isAddToProject, callback) {
        let hasError = false,
            $scrollTo = null;
        //only validate core contact information if they can actually edit it
        //they may only be able to edit the custom fields

        let errorText = 'Required fields are empty or have an incorrect value';
        if (this.options.canEdit) {
            let validate = this.validateCoreFields();
            if (!validate.valid) {
                hasError = true;
                $scrollTo = validate.$scrollTo;
            }

            if (this.model instanceof PJQ.models.users.User) {
                if (this.model.isNew()) {
                    let $username = this.$('.input-username');
                    PJQ.helpers.inputHelpers.setInputError($username, true);
                    if (_.size(this.model.get('username')) === 0) {
                        PJQ.helpers.inputHelpers.setInputError($username, false);
                        hasError = true;
                        if ($scrollTo == null) {
                            $scrollTo = $username;
                        }
                    }

                    let $password = this.$('.input-password');
                    PJQ.helpers.inputHelpers.setInputError($password, true);
                    if (_.size(this.model.get('password')) === 0) {
                        PJQ.helpers.inputHelpers.setInputError($password, false);
                        hasError = true;
                        if ($scrollTo == null) {
                            $scrollTo = $password;
                        }
                    }
                }

                let $itbUser = this.$('.cb-itb-user'),
                    $pmUser = this.$('.cb-pm-user');
                PJQ.helpers.inputHelpers.setInputError($itbUser, true);
                PJQ.helpers.inputHelpers.setInputError($pmUser, true);
                if (!this.model.get('itbUser') && !this.model.get('pmUser')) {
                    PJQ.helpers.inputHelpers.setInputError($itbUser, false);
                    PJQ.helpers.inputHelpers.setInputError($pmUser, false);
                    hasError = true;
                    $scrollTo = this.$('.cb-itb-user');

                    errorText = 'User must be enabled for either ITB or PM features';
                }
            }
        }

        if (this.options.canEditCustomFields) {
            if (this.contactCustomFieldsForm) {
                if (!this.contactCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditContactCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = this.contactCustomFieldsForm.$el;
                    }
                }
            }
            if (this.companyCustomFieldsForm) {
                if (!this.companyCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditCompanyCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = this.companyCustomFieldsForm.$el;
                    }
                }
            }

            if (this.userCustomFieldsForm) {
                if (!this.userCustomFieldsForm.validate()) {
                    let $cac = this.$('#contactEditUserCustomFieldsCollapse');
                    if (!$cac.hasClass('show'))
                        $cac.siblings('.card-header').click();
                    hasError = true;
                    if ($scrollTo == null) {
                        $scrollTo = this.userCustomFieldsForm.$el;
                    }
                }
            }
        }

        if (hasError) {
            new PJQ.Alert(this.$('.validation-error'), {
                type: 'danger',
                text: errorText
            });

            if ($scrollTo != null) {
                this.scrollTo($scrollTo.offset().top);
            }
            return;
        } else {
            this.$('.validation-error').empty();

            if (this.options.isSelfEdit && !this.model.isDirty) {
                // this is a self edit context and the contact wasn't changed
                // don't save to the api to avoid getting added to the approval queue
                // 2025-07-23 - we still need to set the updatedOn in the database for this contact

                let fnDone = _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    return;
                }, this);

                if (this.model instanceof PJQ.models.projectContacts.ProjectContact) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: this.model.get('projectId')
                            },
                            {
                                endpoint: 'contacts',
                                value: this.model.get('id')
                            },
                            {
                                endpoint: 'updated'
                            }])
                    }).post().done(function () {
                        fnDone();
                    });
                } else {
                    fnDone();
                }

                return;
            }
        }

        let currentGroups = this.model.groups,
            currentCompanyCustomFieldValues = this.model.get('companyCustomFieldValues'),
            currentContactCustomFieldValues = this.model.get('contactCustomFieldValues'),
            currentUserCustomFieldValues = this.model.get('userCustomFieldValues');
        if (this.model.get('id') < 0 || (this.model.isNew() && (this.model instanceof PJQ.models.users.User))) {
            if (this.groupSelector != null) {
                this.model.groups.reset(this.groupSelector.getGroupsData().all);
            }

            this.model.set('userCustomFieldValues', this.userCustomFieldsForm != null ? this.userCustomFieldsForm.getChanged() : null);
        } else if (!(this.model.id < 0)) {
            if (this.groupSelector != null) {
                this.model.groups.reset(this.groupSelector.getGroupsData().all);
            }
            this.model.set('companyCustomFieldValues', this.companyCustomFieldsForm != null ? this.companyCustomFieldsForm.getChanged() : null);
            this.model.set('contactCustomFieldValues', this.contactCustomFieldsForm != null ? this.contactCustomFieldsForm.getChanged() : null);
        }

        let loader = new PJQ.Loader(this.$('.modal-content')),
            isNew = this.model.isNew();
        if (isNew && this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
            this.model.set({
                isPreventAddToProject: !isAddToProject,
                isForceSaveExistingEmail: false
            });
        }

        let currentWorkAreas = new PJQ.collections.workAreas.ContactWorkAreas();
        if (isAddNew) {
            _.each(this.model.workAreas.models, _.bind(function (workArea) {
                if (!workArea.get('isDeleted')) {
                    currentWorkAreas.add(new PJQ.models.workAreas.ContactWorkArea({
                        country: workArea.get('country'),
                        state: workArea.get('state'),
                        county: workArea.get('county'),
                        isDeleted: false,
                        workAreaId: workArea.get('workAreaId')
                    }));
                }
            }, this));
        }

        this.model.save(null, {
            notify: false,
            success: _.bind(function (model, data) {
                if (isAddNew) {
                    this.model = new PJQ.models.projectParticipants.ProjectParticipant({
                        projectId: PJQ.app.session.project.id,
                        contactId: 0,
                        contactCompanyId: this.model.get('contactCompanyId'),
                        companyName: this.model.get('companyName'),
                        masterUserId: PJQ.app.session.user.get('masterUserId'),
                        address1: this.model.get('address1'),
                        address2: this.model.get('address2'),
                        city: this.model.get('city'),
                        state: this.model.get('state'),
                        country: this.model.get('country'),
                        zip: this.model.get('zip'),
                        phone: this.model.get('phone'),
                        fax: this.model.get('fax'),
                        groups: currentGroups,
                        companyCustomFieldValues: currentCompanyCustomFieldValues,
                        contactCustomFieldValues: currentContactCustomFieldValues,
                        userCustomFieldValues: currentUserCustomFieldValues
                    });
                    this.model.groups = currentGroups;
                    this.model.workAreas = currentWorkAreas;

                    if (typeof this.options.onAddNew === 'function') {
                        this.options.onAddNew(this.model);
                    } else {
                        this.render();
                    }
                    return;
                }

                let message = 'Successfully saved contact';
                if (this.options.isSelfEdit) {
                    message = 'Successfully saved your info'

                    if (this.featuresDidChange) {
                        PJQ.app.session.fetchSystemPermissions(function () {
                            PJQ.app.navigator.refreshCommands();
                        });
                    }
                } else {
                    if (this.model instanceof PJQ.models.projectContacts.ProjectContact) {
                        if (isNew) {
                            PJQ.app.session.project.projectContacts.add(this.model);
                            message = 'Successfully added project contact';
                        } else {
                            message = 'Successfully saved project contact';
                        }
                    } else if (this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
                        if (isNew) {
                            PJQ.app.session.project.participants.add(this.model);
                            message = isAddToProject ? 'Successfully added bid participant' : 'Successfully saved contact';
                        } else {
                            message = 'Successfully saved contact';
                        }
                    } else if (this.model instanceof PJQ.models.users.User) {
                        if (isNew) {
                            PJQ.app.session.users.add(this.model);
                            message = 'Successfully added user';
                        } else {
                            message = 'Successfully saved user';
                        }
                    }
                }
                PJQ.notifications.notify.successNotify({
                    message: message
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model, isNew);
                }

                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this),
            error: _.bind(function (model, response) {
                if (typeof callback === 'function') {
                    callback(true);
                }

                loader.remove();
                if (response.responseJSON && response.responseJSON.message) {
                    if (response.responseJSON.message === 'ACTIVE_USERS_EXCEEDS_SEATS') {
                        PJQ.app.session.subscription.getCostsPerUser(_.bind(function (changeCosts) {
                            let subscription = PJQ.app.session.subscription,
                                cost;
                            switch (subscription.id) {
                                case PJQ.constants.subscriptions.types.BASIC:
                                    cost = changeCosts.basic;
                                    break;
                                case PJQ.constants.subscriptions.types.PRO:
                                    cost = changeCosts.pro;
                                    break;
                                case PJQ.constants.subscriptions.types.ENTERPRISE:
                                    cost = changeCosts.enterprise;
                                    break;
                                default:
                                    cost = 0;
                                    break;
                            }
                            let userSeatModal = new PJQ.views.modals.YesNo({
                                header: "Not Enough User Seats",
                                body: "You don't have enough user seats to activate this user.  Would you like to add one?  " + PJQ.helpers.formatHelpers.formatCurrency(cost, 2, true) + " will be charged to your credit card on file.",
                                onYes: _.bind(function () {
                                    PJQ.app.session.changeUserSeats(PJQ.app.session.subscription.get('userSeats') + 1, _.bind(function () {
                                        userSeatModal.removeModal();
                                        this.save();
                                    }, this), _.bind(function () {
                                        PJQ.notifications.notify.errorNotify({
                                            message: 'Encountered an error adding user seats.  Please contact customer service.'
                                        });
                                        this.removeModal();
                                    }, this));
                                }, this)
                            });
                        }, this));
                        return;
                    } else if (response.responseJSON.message === 'EmailExists') {
                        new PJQ.views.modals.YesNo({
                            header: "Email Exists",
                            body: "Another contact in your Address Book has this email address already.   Do you still want to save this record?",
                            onYes: _.bind(function () {
                                this.model.set('isForceSaveExistingEmail', true);
                                loader = new PJQ.Loader(this.$('.modal-content'));
                                this.model.save(null, {
                                    success: _.bind(function () {
                                        let message = 'Successfully saved contact';
                                        if (isNew) {
                                            PJQ.app.session.project.participants.add(this.model);
                                            message = isAddToProject ? 'Successfully added bid participant' : 'Successfully saved contact';
                                        }
                                        PJQ.notifications.notify.successNotify({
                                            message: message
                                        });
                                        if (typeof this.options.onSave === 'function') {
                                            this.options.onSave(this.model, isNew);
                                        }

                                        if (typeof callback === 'function') {
                                            callback(true);
                                        }
                                    }, this),
                                    error: function () {
                                        loader.remove();
                                        PJQ.notifications.notify.errorNotify({
                                            message: 'Failed to save'
                                        });
                                    }
                                }, this);
                            }, this)
                        });
                        return;
                    } else if (response.responseJSON.message === 'USERNAME_EXISTS') {
                        new PJQ.Alert(this.$('.validation-error'), {
                            type: 'danger',
                            text: 'The entered username is already taken'
                        });
                        PJQ.helpers.inputHelpers.setInputError(this.$('.input-username'), false);
                        return;
                    }
                }
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to save'
                });
            }, this)
        });
    },
    scrollTo: function (y) {
        if (typeof this.options.scrollTo === 'function') {
            this.options.scrollTo(y);
        } else {
            this.$el.animate({
                scrollTop: y
            }, 500);
        }
    },
    cancel: function () {
        if (this.model.isDirty && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.model.restore();
                    if (typeof this.options.onCancel === 'function') {
                        this.options.onCancel(this.model);
                    }
                }, this)
            });
        } else if (typeof this.options.onCancel === 'function') {
            this.options.onCancel(this.model);
        }
    },
    delete: function () {
        let message = "Are you sure you want to delete this contact?";
        if (this.model instanceof PJQ.models.users.User) {
            message = "Are you sure you want to delete this user?";
        } else if (this.model instanceof PJQ.models.projectContacts.ProjectContact) {
            message = "Are you sure you want to remove this contact from the project?";
        } else if (this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
            message = "Are you sure you want to remove this bid participant from the project?";
        }
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: message,
            onDelete: _.bind(function () {
                this.model.destroy();
                if (this.model instanceof PJQ.models.projectContacts.ProjectContact && PJQ.app.session.project.projectContacts != null) {
                    PJQ.app.session.project.projectContacts.remove(this.model.id);
                    message = "Are you sure you want to remove this contact from the project?";
                } else if (this.model instanceof PJQ.models.projectParticipants.ProjectParticipant) {
                    PJQ.app.session.project.participants.remove(this.model.id);
                    message = "Are you sure you want to remove this bid participant from the project?";
                }
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
            }, this)
        });
    }
});

PJQ.views.contacts.BaseEditContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-contact-edit-base'),
        canEdit: true,
        minWidth: 600,
        maxWidth: 1200,
        isShowAddContact: false,
        alert: null,
        onDelete: _.noop,
        onCancel: _.noop,
        onSave: _.noop
    },
    events: {
        "click .btn-edit-permissions": "editPermissions",
        "click .btn-edit-notifications": "editNotifications",
        "change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
        "keydown .contact-edit-phone-ext": "numbersOnly",
        "click .btn-send-password-reset": "sendPasswordReset",
        "click .contact-edit-add": "addNew",
        "click .contact-edit-cancel": "cancel",
        "click .contact-edit-save": "save",
        "click .contact-edit-save-without-approval": "saveWithoutApproval",
        "click .contact-edit-save-and-add-project": "saveAndAddToProject",
        "click .contact-edit-delete": "delete"
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.contacts.Contact({
                id: this.options.contactId
            });
        }
        this.listenTo(this.model, 'sync', this.render);
        if (!this.model.isNew() && !this.model.isFetched) {
            this.model.fetch();
        } else if (!this.isRendered) {
            this.render();
        }
    },
    beforeRender: function () {
        PJQ.views.contacts.BaseEditContactView.prototype.initPermissionOptions.call(this);
    },
    renderData: function () {
        return {
            model: this.model,
            isSelfEdit: this.options.isSelfEdit,
            isShowAddContact: this.options.isShowAddContact,
            deleteLabel: this.options.deleteLabel ? this.options.deleteLabel : 'Delete',
            canEdit: this.options.canEdit,
            canEditCustomFields: this.options.canEditCustomFields,
            enablePermissions: this.options.enablePermissions,
            isAdmin: this.options.isAdmin,
            canModifyNotifications: this.options.canModifyNotifications
        };
    },
    shouldRenderInnerView: function () {
        return this.model != null && (this.model.isNew() || this.model.isFetched);
    },
    getContactElement: function () {
        return this.$('.modal-body');
    },
    afterRender: function () {
        if (this.shouldRenderInnerView()) {
            let $cel = this.getContactElement(),
                opts = _.extend(this.getInnerViewOptions(), {
                    el: $cel,
                    len: $cel.length,
                    scrollTo: _.bind(function (y) {
                        $('div.modal').animate({
                            scrollTop: y
                        }, 500);
                    }, this),
                    onAddNew: _.bind(function (model) {
                        this.model = model;
                        this.render();
                    }, this),
                    onSave: _.bind(function (model, isNew, options = {contextClosed: true}) {
                        if (options.contextClosed !== false) {
                            this.removeModal();
                        }
                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(model, isNew);
                        }
                    }, this),
                    onCancel: _.bind(function (model, options = {contextClosed: true}) {
                        if (options.contextClosed !== false) {
                            this.removeModal();
                        }
                        if (typeof this.options.onCancel === 'function') {
                            this.options.onCancel(model);
                        }
                    }, this),
                    onDelete: _.bind(function (model, options = {contextClosed: true}) {
                        if (options.contextClosed !== false) {
                            this.removeModal();
                        }
                        if (typeof this.options.onDelete === 'function') {
                            this.options.onDelete(model);
                        }
                    }, this)
                });
            this.editView = new (this.getInnerViewType())(opts);
        }
    },
    getInnerViewType: function () {
        return PJQ.views.contacts.BaseEditContactView;
    },
    getInnerViewOptions: function () {
        return {
            model: this.model,
            modal: this
        };
    },
    editPermissions: function () {
        this.editView.editPermissions();
    },
    editNotifications: function () {
        this.editView.editNotifications();
    },
    addNew: function () {
        this.editView.save(null, true);
    },
    saveAndAddToProject: function () {
        this.editView.saveAndAddToProject(...arguments);
    },
    save: function () {
        this.editView.save(...arguments);
    },
    cancel: function () {
        this.editView.cancel(...arguments);
    },
    delete: function () {
        this.editView.delete(...arguments);
    }
});

PJQ.views.contacts.SelectContactsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'modal-contacts-select'),
        onCancel: _.noop,
        onSave: _.noop,
        hideContacts: null,
        hideEmails: null,
        disableBadEmail: false,
        disableBlacklisted: false,
        disableContacts: null,
        isSingleChoice: true,
        contacts: null,
        showAddress: false,
        context: PJQ.constants.contacts.contexts.CONTACTS,
        minWidth: '500px',
        width: '100%',
        maxWidth: '1000px',
        userTypeFilter: null,
        isUserTypeFilterDisabled: false,
        titleOverride: null,
        canSwitchContext: false,
        hideUsers: false,
        shouldHideContacts: false,
        enableSelectAll: false,
        saveButtonText: 'Save'
    },
    events: {
        "change .select-contact": "selectContact",
        "click .contacts-select-cancel": "cancel",
        "click .contacts-select-save": "save",
        'click .switch-context': 'switchContext',
        'click .project-contacts-new-contact': 'newContactClicked',
        'click .project-contacts-add-from-bid-participants': 'addFromBidParticipants',
        'click .project-contacts-add-from-address-book': 'addFromAddressBook',
        'click .project-contacts-quick-search': 'quickSearch',
        'click .project-contacts-add-from-project': 'addFromProject',
        'click .project-contacts-add-from-company': 'addFromCompany',
        'click .select-all-contacts': 'selectAllContacts',
    },
    beforeModalCreated: function () {
        this.options.project = PJQ.app.session.project ? PJQ.app.session.project : null;
        this.options.isAdmin = this.options.project ? this.options.project.hasPermission('projectContacts.isAdmin') : false;
        this.selectedContact = this.options.isSingleChoice ? null : [];

        let context = this.options.context;
        if (context === PJQ.constants.contacts.contexts.USERS) {
            if (this.users == null) {
                this.users = new PJQ.collections.users.Users();
                this.listenTo(this.users, 'sync', this.render);
                this.users.fetch();
            } else {
                this.listenTo(this.users, 'sync', this.render);
            }
        } else {
            if (this.options.contacts) {
                this.contacts = this.options.contacts;
            }
            if (this.contacts == null) {
                let contactsRef = [];
                let fnGet = _.bind(function (ctx) {
                    switch (ctx) {
                        case PJQ.constants.contacts.contexts.PARTICIPANTS:
                            return PJQ.app.session.project.participants;
                        case PJQ.constants.contacts.contexts.PROJECTCONTACTS:
                            return PJQ.app.session.project.projectContacts;
                        case PJQ.constants.contacts.contexts.CONTACTS:
                        default:
                            return new PJQ.collections.contacts.Contacts();
                    }
                }, this);
                this.forParticipants = false;
                if (PJQ.helpers.objectHelpers.refinedType(this.options.context) === 'array') {
                    _.each(this.options.context, function (ctx) {
                        contactsRef.push(fnGet(ctx));

                        if (ctx === PJQ.constants.contacts.contexts.PARTICIPANTS) {
                            this.forParticipants = true;
                        }
                    }, this);
                } else {
                    this.contacts = fnGet(this.options.context);

                    if (this.options.context === PJQ.constants.contacts.contexts.PARTICIPANTS) {
                        this.forParticipants = true;
                    }
                }

                let fnContinue = _.bind(function () {
                    if (_.size(contactsRef) > 0) {
                        this.contacts = new PJQ.collections.contacts.Contacts();
                        let fnFetch = (index) => {
                            if (_.size(contactsRef) > index) {
                                contactsRef[index].fetch({
                                    success: _.bind(function (ctn) {
                                        this.contacts.add(ctn.models);
                                        fnFetch(index + 1);
                                    }, this)
                                });
                            } else {
                                this.render();
                            }
                        };
                        fnFetch(0);
                    } else if (this.options.context !== PJQ.constants.contacts.contexts.CONTACTS && !this.contacts.isFetched) {
                        this.contacts.fetch();
                        this.listenTo(this.contacts, 'reset update', _.bind(function () {
                            this.render();
                        }, this));

                        this.listenTo(this.contacts, 'sync', _.bind(function () {
                            this.dataTable.refresh('page');
                        }, this));
                    }
                }, this)

                if (this.forParticipants) {
                    this.options.project.getProjectStatuses(_.bind(function (statuses) {
                        this.projectStatuses = statuses;
                        fnContinue();
                    }, this));
                } else {
                    fnContinue();
                }
            } else {
                this.listenTo(this.contacts, 'reset update', _.bind(function () {
                    this.render();
                }, this));

                this.listenTo(this.contacts, 'sync', _.bind(function () {
                    this.dataTable.refresh('page');
                }, this));
            }
        }
    },
    beforeRender: function () {
        if (this.options.titleOverride) {
            this.options.title = this.options.titleOverride;
        } else {
            if (this.options.context === PJQ.constants.contacts.contexts.USERS) {
                this.options.title = "Select User";
            } else if (this.options.context === PJQ.constants.contacts.contexts.PROJECTCONTACTS) {
                this.options.title = "Select Project Contact";
            } else if (this.options.context === PJQ.constants.contacts.contexts.PARTICIPANTS) {
                this.options.title = "Select Bid Participant";
            } else if (this.options.context === PJQ.constants.contacts.contexts.COMPANIES) {
                this.options.title = "Select Company"
            } else {
                this.options.title = "Select Contact";
            }
        }

        if (!this.options.isSingleChoice) {
            this.options.title += 's';
        }
        this.renderData = {
            options: this.options
        };
    },
    afterRender: function () {
        let columns = [],
            isUsersOnly = this.options.context === PJQ.constants.contacts.contexts.USERS;
        if (isUsersOnly) {
            columns = [
                {
                    "data": "attributes.id",
                    "title": !this.options.enableSelectAll ? "" : '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let isSelected = false;
                        if (this.selectedContact != null) {
                            if (this.options.isSingleChoice && this.selectedContact != null) {
                                isSelected = this.selectedContact.id === data;
                            } else {
                                isSelected = _.find(this.selectedContact, function (contact) {
                                    return data === contact.id;
                                }) != null;
                            }
                        }
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (isSelected ? ' checked ' : '') + ' class="select-contact" ' + (row.get('isBlacklisted') ? 'disabled' : '') + '/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this)
                },
                {
                    'title': "Active",
                    "data": "attributes.isActive",
                    'width': '40px',
                    "render": _.bind(function (data, type, row) {
                        let content = '';
                        if (data === true) {
                            content = '<i class="fas fa-circle" style="color: #5cb85c"><div hidden>true</div></i>'
                        } else {
                            content = '<i class="fas fa-circle" style="color: #d9534f"><div hidden>false</div></i>'
                        }
                        return content
                    })
                },
                {
                    "title": "Type",
                    "width": "120px",
                    "orderable": true,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let userType;
                        if (row.userType != null) {
                            userType = row.userType;
                        } else {
                            userType = PJQ.app.session.userTypes.getDefault(row.get('id') < 0);
                        }
                        if (type === 'sort') {
                            return userType.get('sortOrder');
                        }
                        return '<span style="color:' + userType.get('color') + ';">' + userType.get('name') + '</span>';
                    }, this)
                },
                {"data": "attributes.contactName", "title": "Contact Name"},
                {"data": "attributes.email", "title": "Email"}
            ];
        } else {
            columns = [
                {
                    "data": "attributes.id",
                    "title": !this.options.enableSelectAll ? "" : '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-contacts" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let isSelected = false, isDisabled = false;

                        if (this.selectedContact != null) {
                            if (this.options.isSingleChoice) {
                                isSelected = this.selectedContact.id === data;
                            } else {
                                isSelected = _.find(this.selectedContact, function (contact) {
                                    return data === contact.id;
                                }) != null;
                            }
                        }

                        if (row.get('isBlacklisted')) {
                            isDisabled = true
                        } else if (this.options.disableContacts) {
                            if (this.options.isSingleChoice) {
                                if (this.options.disableContacts.id === data) {
                                    isDisabled = true;
                                }
                            } else {
                                if (_.find(this.options.disableContacts, function (disableContact) {
                                    return disableContact.id === data;
                                }) !== undefined) {
                                    isSelected = true;
                                    isDisabled = true;
                                }
                            }
                        }

                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (isSelected ? 'checked' : '') + (isDisabled ? ' disabled' : '') + ' class="select-contact"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this)
                },
                {
                    "data": "userType",
                    "title": "Type",
                    "width": "120px",
                    "orderable": true,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        let userType;
                        if (row.userType != null) {
                            userType = row.userType;
                        } else {
                            userType = PJQ.app.session.userTypes.getDefault(row.get('id') < 0);
                        }
                        if (type === 'sort') {
                            return userType.get('sortOrder');
                        }
                        return '<span style="color:' + userType.get('color') + ';">' + userType.get('name') + '</span>';
                    }, this)
                },
                {"data": "attributes.companyName", "title": "Company Name"},
                {"data": "attributes.contactName", "title": "Contact Name"},
                {"data": "attributes.email", "title": "Email"}
            ];

            if (this.projectStatuses != null) {
                columns.push({
                    "data": "attributes.status",
                    "title": 'Status',
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let status = _.size(data) > 0 ? data.toUpperCase() : 'PENDING';
                        return '<span style="color:' + this.getStatusColor(status) + '">' + status + '</span>';
                    }, this)
                });
            }
        }

        if (this.options.showAddress) {
            columns.push({"data": "attributes.address1", "title": "Address"});
            columns.push({"data": "attributes.city", "title": "City"});
            columns.push({"data": "attributes.state", "title": "State"});
        }

        let getPageCallback = null,
            data;
        if (this.options.context === PJQ.constants.contacts.contexts.CONTACTS) {
            getPageCallback = _.bind(function (pageNumber, pageSize, orderArr, callback) {
                let order = orderArr[0];
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'contacts'
                        }], [
                        {
                            parameter: 'search',
                            value: this.$('.datatable-search').val(),
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'page',
                            value: pageNumber
                        },
                        {
                            parameter: 'pageSize',
                            value: pageSize
                        },
                        {
                            parameter: 'orderBy',
                            value: order.name,
                        },
                        {
                            parameter: 'orderDirection',
                            value: order.direction
                        },
                        {
                            parameter: 'userTypes',
                            value: this.dataTable ? this.dataTable.userTypeFilter : null,
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'projectId',
                            value: this.options.project ? this.options.project.id : null,
                            includeIfEmpty: false
                        }
                    ])
                }).get().success(_.bind(function (data) {
                    let newContacts = new PJQ.collections.contacts.Contacts(data.contacts);
                    callback(newContacts.models, data.totalRows);
                }, this)).fail(_.bind(function (xhr) {
                    callback();
                }, this));
            }, this);
        } else if (this.options.context === PJQ.constants.contacts.contexts.COMPANIES) {
            getPageCallback = _.bind(function (pageNumber, pageSize, orderArr, callback) {
                let order = orderArr[0];
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'companiessimple'
                        }], [
                        {
                            parameter: 'search',
                            value: this.$('.datatable-search').val(),
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'page',
                            value: pageNumber
                        },
                        {
                            parameter: 'pageSize',
                            value: pageSize
                        },
                        {
                            parameter: 'orderBy',
                            value: order.name,
                        },
                        {
                            parameter: 'orderDirection',
                            value: order.direction
                        },
                        {
                            parameter: 'userTypes',
                            value: this.dataTable ? this.dataTable.userTypeFilter : null,
                            includeIfEmpty: false
                        },
                        {
                            parameter: 'projectId',
                            value: this.options.project ? this.options.project.id : null,
                            includeIfEmpty: false
                        }
                    ])
                }).get().success(_.bind(function (data) {
                    let newContacts = new PJQ.collections.contacts.Contacts(data.companies);
                    callback(newContacts.models, data.totalRows);
                }, this)).fail(_.bind(function (xhr) {
                    callback();
                }, this));
            }, this);
        } else {
            data = this.getContactsList();
        }

        if (_.size(data) > 0 && this.options.hideUsers) {
            data = _.filter(data, function (model) {
                return model.get('contactId') > 0;
            }, this)
        }

        if (_.size(data) > 0 && this.options.shouldHideContacts) {
            data = _.filter(data, function (model) {
                return model.get('contactId') == null;
            }, this)
        }

        let userTypes,
            zeroRecordsLabel,
            emptyTableLabel;

        if ((this.options.context === PJQ.constants.contacts.contexts.USERS)) {
            userTypes = PJQ.app.session.userTypes.getByIsCompany(true);
            zeroRecordsLabel = "No users match the search criteria";
            if (_.size(data) === 0 && _.size(this.users.models) > 0) {
                emptyTableLabel = "All users have already been added";
            } else {
                emptyTableLabel = "You don't have any other users in your company";
            }
        } else if (this.options.context === PJQ.constants.contacts.contexts.PARTICIPANTS) {
            userTypes = PJQ.app.session.userTypes.getByIsCompany(false);
            zeroRecordsLabel = "No bid participants match the search criteria";
            if (_.size(data) === 0 && _.size(this.contacts.models) > 0) {
                emptyTableLabel = "All bid participants have already been added";
            } else {
                emptyTableLabel = "No bid participants have been added to this project";
            }
        } else if (this.options.context === PJQ.constants.contacts.contexts.PROJECTCONTACTS) {
            userTypes = PJQ.app.session.userTypes.getByIsCompany();
            zeroRecordsLabel = "No project contacts match the search criteria";
            if (_.size(data) === 0 && (this.contacts == null || _.size(this.contacts.models) > 0)) {
                emptyTableLabel = "All project contacts have already been added";
            } else {
                emptyTableLabel = "No project contacts have been added to this project";
            }
        } else {
            if (this.options.context === PJQ.constants.contacts.contexts.CONTACTS) {
                userTypes = PJQ.app.session.userTypes.getByIsCompany(false);
            } else {
                userTypes = _.union(PJQ.app.session.userTypes.getByIsCompany(), PJQ.app.session.userTypes.getByIsCompany(false));
            }
            zeroRecordsLabel = "No contacts match the search criteria";
            if (_.size(data) === 0 && (this.contacts == null || _.size(this.contacts.models) > 0)) {
                emptyTableLabel = "All contacts have already been added";
            } else {
                emptyTableLabel = "No contacts match the search criteria";
            }
        }

        this.dataTable = new PJQ.views.contacts.ContactSelectDataTable({
            el: this.$('.contacts-data-table'),
            data: data,
            deferRender: true,
            order: this.options.context === PJQ.constants.contacts.contexts.USERS ? [2, 'asc'] : [1, 'asc'],
            columns: columns,
            userTypeFilter: this.options.userTypeFilter,
            isUserTypeFilterDisabled: this.options.isUserTypeFilterDisabled,
            headerData: {
                userTypes: userTypes,
                projectStatuses: this.projectStatuses,
                filterGroups: this.forParticipants,
                context: this.options.context,
                isAdmin: this.options.isAdmin
            },
            language: {
                emptyTable: emptyTableLabel,
                zeroRecords: zeroRecordsLabel
            },
            getPageCallback: getPageCallback,
            createdRow: _.bind(this.createdRow, this)
        });
    },
    getStatusColor: function (name) {
        let status = _.find(this.projectStatuses, function (status) {
            return status.name.toUpperCase() === name.toUpperCase();
        });

        return status != null ? status.backgroundColor : "#eee";
    },
    switchContext: function () {
        this.options.context = this.options.context === PJQ.constants.contacts.contexts.CONTACTS ? PJQ.constants.contacts.contexts.USERS : PJQ.constants.contacts.contexts.CONTACTS
        this.render();
    },
    getContactsList: function () {
        let contacts = [];
        if (this.users != null && this.users.length > 0)
            contacts = _.union(contacts, this.users.models);
        if (this.contacts != null && this.contacts.length > 0)
            contacts = _.union(contacts, this.contacts.models);

        if (this.options.hideContacts) {
            if (this.options.isSingleChoice) {
                contacts = _.filter(contacts, _.bind(function (contact) {
                    return (contact.id !== this.options.hideContacts.id);
                }, this));
            } else {
                contacts = _.filter(contacts, _.bind(function (contact) {
                    return _.find(this.options.hideContacts, function (hideContact) {
                        return hideContact.id === contact.id;
                    }) == null;
                }, this));
            }
        }

        if (this.options.hideEmails && Array.isArray(this.options.hideEmails) && _.size(this.options.hideEmails) > 0) {
            let hideEmailsLower = this.options.hideEmails.map(email => email.toLowerCase());
            contacts = _.filter(contacts, (contact) => {
                let contactEmail = contact.get('email')?.toLowerCase();
                return !hideEmailsLower.includes(contactEmail);
            });
        }

        return contacts;
    },
    createdRow: function (row, data, dataIndex) {
        if (data.attributes.isBlacklisted)
            $(row).css({cssText: 'text-decoration: line-through !important;'});
    },
    selectAllContacts: function (e) {
        let $target = $(e.currentTarget),
            isChecked = $target.prop('checked');

        if (!isChecked) {
            this.selectedContact = (this.options.isSingleContact ? null : []);
        } else {
            this.selectedContact = this.getContactsList();
        }

        this.$('.select-contact').prop('checked', isChecked);
        this.$('.contacts-select-save').prop('disabled', this.selectedContact == null || _.size(this.selectedContact) === 0);
    },
    selectContact: function (e) {
        let target = $(e.currentTarget),
            isSelected = target.prop('checked');
        if (this.options.isSingleChoice)
            this.$('.select-contact').not(target).prop('checked', false);

        let data = this.dataTable.dataTable.row(target.parents('tr')).data();
        if (isSelected) {
            if (this.options.isSingleChoice)
                this.selectedContact = data;
            else
                this.selectedContact.push(data);
        } else {
            if (this.options.isSingleChoice)
                this.selectedContact = null;
            else
                this.selectedContact = _(this.selectedContact).filter(function (item) {
                    return item.attributes.id !== data.attributes.id
                });
        }
        this.$('.contacts-select-save').prop('disabled', this.selectedContact == null || _.size(this.selectedContact) === 0);
    },
    addFromBidParticipants: function () {
        this.options.project.fetchParticipants(_.bind(function (participants) {
            new PJQ.views.contacts.SelectContactsModal({
                contacts: participants,
                hideContacts: this.contacts.models,
                context: PJQ.constants.contacts.contexts.PARTICIPANTS,
                isSingleChoice: false,
                subtitle: "Add Project Contacts from Bid Participants",
                onSave: _.bind(function (selectedContacts) {
                    this.contacts.addContactsToProject(_.map(selectedContacts, function (contact) {
                        return contact.id;
                    }), () => {
                        this.render();
                    });
                }, this)
            });
        }, this));
    },
    addFromAddressBook: function () {
        $('form[name="modal-add-participants"]').remove();
        let options = {
            onSave: (selectedContactsAll, data) => {
                this.contacts.addContactsToProject(selectedContactsAll, () => {
                    this.render();
                });
            },
            disableContacts: _.map(this.contacts.models, function (contact) {
                return contact.id;
            })
        };

        if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DISABLE_NEW_ADDRESSBOOK)) {
            options.isWrapForm = false;
            options.wrapFormName = null;
            options.isUseNewAddressBook = true;
            options.isMultipleProjects = true;
        }

        new PJQ.views.projects.AddParticipantsDetailedModal(options);
    },
    quickSearch: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.CONTACTS,
            isSingleChoice: false,
            project: this.options.project,
            subtitle: "Add Project Contacts From Address Book",
            onSave: _.bind(function (selectedContacts) {
                this.contacts.addContactsToProject(_.map(selectedContacts, function (contact) {
                    return contact.id;
                }), () => {
                    this.render();
                });
            }, this)
        });
    },
    addFromProject: function () {

    },
    addFromCompany: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.USERS,
            isSingleChoice: false,
            hideContacts: this.contacts.models,
            subtitle: "Add Project Contacts from My Company Users",
            onSave: _.bind(function (selectedContacts) {
                this.contacts.addContactsToProject(_.map(selectedContacts, function (contact) {
                    return -contact.id;
                }), () => {
                    this.render();
                });
            }, this)
        });
    },
    newContactClicked: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                projectId: this.options.project.id,
                country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US'
            })
        });
    },
    newUserClicked: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectContacts.ProjectContact({
                projectId: this.options.project.id
            })
        });
    },
    save: function () {
        let callback = _.bind(function () {
            this.options.onSave(this.selectedContact);
            this.removeModal();
        }, this);

        if (this.options.disableBadEmail) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'checkpcg'
                    }]),
                data: {
                    contactIds: this.options.isSingleChoice ? [this.selectedContact] : _.map(this.selectedContact, function (selectedContact) {
                        return selectedContact.get('contactId');
                    }),
                    contactCompanyIds: [],
                    contactGroupIds: []
                }
            }).post().done(_.bind(function (data) {
                if (data.results.length > 0) {
                    new PJQ.views.projects.AddParticipantsErrorModal({
                        data: data.results,
                        onContinue: _.bind(function () {
                            // remove bad items from this.selectedContact
                            _.each(data.results, _.bind(function (contact) {
                                if (this.options.isSingleChoice && contact.contactId === this.selectedContact.get('contactId'))
                                    this.selectedContact = null;
                                else if (!this.options.isSingleChoice) {
                                    this.selectedContact = _.filter(this.selectedContact, _.bind(function (selectedContact) {
                                        return selectedContact.get('contactId') !== contact.contactId;
                                    }, this));
                                }
                            }, this));

                            callback();
                        }, this)
                    });
                } else
                    callback();

            }, this)).fail(function () {
            });
        } else {
            callback();
        }
    },
    cancel: function () {
        this.options.onCancel();
    }
});

PJQ.views.contacts.ContactSelectDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Contact-Select')
        },
        userTypeFilter: null,
        isUserTypeFilterDisabled: false
    },
    events: {
        'keyup .datatable-search': 'search',
        "click .btn-filter-groups": "filterGroups",
        'click .contact-select-clear-filters': 'clearFilters'
    },
    beforeDataTableRender: function () {
        if (this.options.userTypeFilter)
            this.userTypeFilter = this.options.userTypeFilter;

        this.filterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.contacts-filter'),
            onChange: _.bind(function (value) {
                let companyUserTypes = value["companyUserType"],
                    contactUserTypes = value["contactUserType"];

                this.userTypeFilter = [];
                if (_.size(companyUserTypes) > 0) {
                    this.userTypeFilter.push(...companyUserTypes);
                }
                if (_.size(contactUserTypes) > 0) {
                    this.userTypeFilter.push(...contactUserTypes);
                }

                this.projectStatusFilter = value["projectStatus"];

                this.filter();
            }, this),
            isGrouped: true,
            isMultiple: true,
            isDisabled: this.options.isUserTypeFilterDisabled,
            defaultValue: this.userTypeFilter,
            noneSelectedText: 'No Filters'
        });
    },
    getFilterData: function () {
        if (_.size(this.userTypeFilter) === 0 && _.size(this.projectStatusFilter) === 0 && _.size(this.groupsFilter) === 0) {
            return this.options.data;
        }

        let results = this.options.data;
        if (_.size(this.userTypeFilter) > 0) {
            results = _.filter(results, function (row) {
                return _.contains(this.userTypeFilter, row.userType.id.toString());
            }, this);
        }

        if (_.size(this.groupsFilter) > 0) {
            results = _.filter(results, function (row) {
                let noGroups = _.contains(this.groupsFilter, 0);
                return (noGroups && _.size(row.groups.models) === 0) || _.find(row.groups.models, _.bind(function (group) {
                    return _.contains(this.groupsFilter, group.id);
                }, this)) != null;
            }, this);
        }

        if (_.size(this.projectStatusFilter) > 0) {
            return _.filter(results, function (row) {
                let st = row.get('status');
                if (_.size(st) === 0) {
                    st = "PENDING";
                }
                return _.size(st) > 0 && _.contains(this.projectStatusFilter, st.toUpperCase());
            }, this);
        } else {
            return results;
        }
    },
    filterGroups: function () {
        new PJQ.views.addressbook.FilterTradesModal({
            selectedGroups: this.groupsFilter,
            onFilter: _.bind(function (groups) {
                this.updateGroupsFilter(groups);
                this.filter();
            }, this)
        });
    },
    updateGroupsFilter: function (groups) {
        this.groupsFilter = groups;

        let groupLen = _.size(groups)
        this.$('.filter-groups-text').text((groupLen > 0 ? groupLen.toString() : 'All') + ' Trades');
    },
    afterSearch: function () {
        this.$('.contact-select-clear-filters').prop('disabled', _.size(this.$('input.datatable-search').val()) === 0 && _.size(this.userTypeFilter) === 0 && _.size(this.projectStatusFilter) === 0 && _.size(this.groupsFilter) === 0);
    },
    clearFilters: function () {
        this.userTypeFilter = null;
        this.projectStatusFilter = null;
        this.updateGroupsFilter(null);
        this.filterPicker.deselectAll();
        this.$('input.datatable-search').val('');
        this.filter();
    }
});

PJQ.views.contacts.ContactsSelectInput = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input'),
        subTemplates: {
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts')
        },
        contacts: null,
        selectedContact: null,
        disableContacts: null,
        isSingleChoice: true,
        isShowAddButtonByLabel: true,
        addButton: null,
        onAdd: _.noop,
        onChange: _.noop,
        onDelete: _.noop,
        context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
        emptyNotice: "No Contacts Selected",
        isRequired: false,
        isReadOnly: null, // this value is null by default, if its not null it will be used to set canEdit
        showSelectorAddress: false,
        contactsRenderData: null,
        isSortable: false,
        onStop: _.noop,
        canSwitchContext: false,
        canViewContacts: null,
        canEdit: true,
        hideUsers: false,
        shouldHideContacts: false,
        saveButtonText: null
    },
    events: {
        "click .btn-approve-behalf": "approveBehalf",
        "click .contact-select-input-add": "edit",
        "click .contact-select-input-delete": "deleteContact"
    },
    beforeRender() {
        this.selectedContact = this.options.selectedContact ? this.options.selectedContact : (this.options.isSingleChoice ? null : []);

        if (!this.options.isSingleChoice && this.selectedContact != null && PJQ.helpers.objectHelpers.refinedType(this.selectedContact) !== 'array') {
            this.selectedContact = [this.selectedContact];
        }

        if (this.options.isReadOnly != null) {
            this.options.canEdit = !this.options.isReadOnly;
        }
    },
    afterRender() {
        if (this.options.addButton != null && this.options.canEdit) {
            this.options.addButton.off().on('click', _.bind(this.edit, this));
        } else if (this.options.canEdit) {
            let addButton = $('<button type="button" class="btn btn-transparent-light text-info btn-sm contact-select-input-add ml-1"><i class="fal fa-pencil"></i></button>');
            if (this.options.isShowAddButtonByLabel) {
                this.$el.closest('.form-group').find('label').append(addButton);
                addButton.on('click', _.bind(this.edit, this));
            } else {
                this.find('.contact-select-input-buttons').append(addButton);
            }
        }

        if (this.options.isSortable) {
            let self = this;
            self.approversSortable = new PJQ.Sortable(self.$('.contact-select-list'), {
                containment: "document",
                items: '.select-contact-container',
                connectWith: '.select-contact-container',
                onStop: _.bind(function () {
                    // self.options.onStop();
                    let dataArray = []
                    self.$('.select-contact-container').each(function (a, b) {
                        let data = $(b).data('contactId');
                        dataArray.push(data);
                    });
                    self.options.onStop(dataArray);
                }, this)
            });
        }

        this.renderSelectedContact();
    },
    approveBehalf: function (e) {
        let id = $(e.target).closest('.select-contact-container').data('contactId'),
            contact = _.find(this.selectedContact, function (contact) {
                return contact.id === id
            });
        if (typeof this.options.onApproveBehalf === 'function') {
            this.options.onApproveBehalf(contact);
        }
    },
    deleteContact: function (e) {
        let cid = $(e.target).closest('.select-contact-container').data('cid');
        if (this.options.isSingleChoice) {
            this.options.onDelete(this.selectedContact, null);
            this.options.onChange(null);
            this.selectedContact = null;
        } else {
            let deletedContact = _.find(this.selectedContact, function (contact) {
                return contact.cid === cid;
            });
            if (deletedContact != null) {
                this.selectedContact = _.filter(this.selectedContact, function (contact) {
                    return contact.cid !== cid;
                });
                this.options.onDelete(deletedContact, this.selectedContact);
                this.options.onChange(this.selectedContact);
            }
        }
        this.renderSelectedContact();
    },
    edit: function () {
        this.selector = new PJQ.views.contacts.SelectContactsModal({
            contacts: this.options.contacts,
            hideUsers: this.options.hideUsers,
            shouldHideContacts: this.options.shouldHideContacts,
            hideContacts: this.options.allowDuplicate ? null : this.selectedContact,
            disableContacts: this.options.disableContacts,
            context: this.options.context,
            canSwitchContext: this.options.canSwitchContext,
            showAddress: this.options.showSelectorAddress,
            isSingleChoice: this.options.isSingleChoice,
            saveButtonText: this.options.saveButtonText,
            onSave: (newContacts) => {
                if (this.options.allowDuplicate && !this.options.isSingleChoice) {
                    this.selectedContact.push(...newContacts);
                } else {
                    this.selectedContact = this.options.isSingleChoice ? newContacts : _.union(this.selectedContact, newContacts);
                }
                this.renderSelectedContact();
                this.options.onAdd(newContacts, this.selectedContact);
                this.options.onChange(this.selectedContact);
            }
        });
    },
    renderSelectedContact: function () {
        let data = this.selectedContact;
        if (this.selectedContact && this.options.isSingleChoice)
            data = [this.selectedContact];

        if (_.size(data) === 0) {
            this.$('.contact-select-list').html('<div class="text-muted font-weight-light mt-1 fs-16">' + this.options.emptyNotice + '</div>');
        } else {
            let crd;
            if (typeof this.options.contactsRenderData === 'function') {
                crd = this.options.contactsRenderData(data);
            } else {
                crd = this.options.contactsRenderData ? this.options.contactsRenderData : {};
            }

            this.renderSubTemplate(false, this.options.subTemplates.contactBadge, this.$('.contact-select-list'),
                {
                    models: data,
                    contactsRenderData: crd,
                    isSingleChoice: this.options.isSingleChoice,
                    displayContactsBlock: this.options.displayContactsBlock,
                    canView: this.options.canViewContacts ?? this.options.canEdit,
                    canEdit: this.options.canEdit
                });
        }
    },
    validate: function () {
        if (_.size(this.selectedContact) > 0) {
            return true;
        } else {
            this.$('.contact-select-list').html('<div class="text-danger mt-1">This field is required.</div>');
            return false;
        }
    }
});

PJQ.views.contacts.ReportContactModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Report-Contact'),
        minWidth: '400px',
        reason: "",
        onReport: null,
        showRemoveFromProject: false
    },
    events: {
        'keyup .input-other-reason': 'otherReasonChanged',
        'click .btn-report': 'reportParticipant'
    },
    afterRender: function () {
        new PJQ.inputs.Selectpicker({
            noneSelectedText: 'Select Reason',
            el: this.$('.select-reason'),
            onChange: _.bind(function (value) {
                if (value && value.toLowerCase() === 'other') {
                    this.$('.other-reason').removeClass('hidden');
                } else {
                    this.$('.other-reason').addClass('hidden');
                }
                this.setReason(value);
            }, this)
        });

        if (this.options.showRemoveFromProject)
            this.$('.remove-from-project').removeClass('hidden');
    },
    otherReasonChanged: function (e) {
        this.setReason($(e.currentTarget).val());
    },
    setReason: function (reason) {
        this.options.reason = reason;
        this.$('.btn-report').prop('disabled', _.size(this.options.reason) === 0);
    },
    reportParticipant: function () {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.options.contactId
                },
                {
                    endpoint: 'report'
                }
            ]),
            data: {
                projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null,
                reason: this.options.reason,
                removeFromProject: this.$('.input-remove-from-project').prop('checked')
            }
        }).post().done(_.bind(function (data) {
            if (typeof this.options.onReport === 'function') {
                this.options.onReport(this.$('.input-remove-from-project').prop('checked'));
            }

            this.removeModal();

            PJQ.notifications.notify.successNotify({
                message: 'Contact successfully reported'
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
            this.removeModal();

            PJQ.notifications.notify.errorNotify({
                message: 'Failed to report contact'
            });

            new PJQ.logging.Debug(PJQ.logging.LoggingActions.REPORT_CONTACT, {
                error: err,
                result: result
            });
        }, this));
    }
});
